import { FrontendConfiguration } from '../interfaces';

export const HSP_CONFIGURATION = {
    name: 'HSP v0.1 flow',
    exportedAt: '2026-06-11T07:39:19.227Z',
    compiledFlowBlocks: {
        'fbd8448a-ed5d-42e4-9d25-4092f150d5df': {
            id: '0',
            name: 'End of the flow special block',
            blockType: 'END_OF_THE_FLOW_BLOCK',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'fbd8448a-ed5d-42e4-9d25-4092f150d5df',
            inputParameters: [],
            outputParameters: []
        },
        '5fbaaca6-5107-432e-a7fa-1dd00ac79727': {
            id: '9588f1b1-3c8a-4a23-a8ae-1ecd30906d79',
            name: 'Section - General',
            blockType: 'SECTION_BLOCK',
            isVirtual: false,
            titleKey: 'QUESTION_FLOW.SECTIONS.9588f1b1-3c8a-4a23-a8ae-1ecd30906d79.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '5fbaaca6-5107-432e-a7fa-1dd00ac79727',
            inputParameters: [],
            outputParameters: []
        },
        'c2b8d035-968f-44bc-bd21-c6ad1df98c49': {
            id: '03663e41-b867-4b0e-97eb-7aaace9c9e59',
            name: 'Systems of interest',
            blockType: 'SUB_SECTION_BLOCK',
            isVirtual: false,
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.03663e41-b867-4b0e-97eb-7aaace9c9e59.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'c2b8d035-968f-44bc-bd21-c6ad1df98c49',
            inputParameters: [],
            outputParameters: []
        },
        '8b5b392a-8cfd-48ed-9a37-0eff67639be6': {
            id: '4248e3c8-8343-4a98-acdb-8dfafbe3b73a',
            name: 'Interests - HEATING',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'CHECKBOX_TILE_SLOT',
                        id: 'Oi3ykiw',
                        outputParameter: 'project.initialEndCustomerInterest.heating',
                        outputParameterType: 'ARRAY',
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.TARGET_INSTALLATION_SYSTEMS.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.TARGET_INSTALLATION_SYSTEMS.{{value}}.LABEL',
                        dataSource: 'TARGET_INSTALLATION_SYSTEMS',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.TARGET_INSTALLATION_SYSTEMS.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'TARGET_INSTALLATION_SYSTEMS'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['GAS_BOILER_SYSTEM', 'HEAT_PUMP_SYSTEM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.TARGET_INSTALLATION_SYSTEMS.selectedItems',
                        validations: [
                            {
                                id: 'EdkxnXj',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.initialEndCustomerInterest.heating',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'initialEndCustomerInterest'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'heating'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.4248e3c8-8343-4a98-acdb-8dfafbe3b73a.SLOTS.Oi3ykiw.VALIDATIONS.EdkxnXj.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        visual: {
                            visualType: 'ICON',
                            visualId: 'DATA_SOURCES.TARGET_INSTALLATION_SYSTEMS.{{value}}.ICON'
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.initialEndCustomerInterest.heating',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'initialEndCustomerInterest'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heating'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'diQVzBz',
                        outputParameter: 'project.projectType',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: 'MODERNISATION'
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.projectType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'projectType'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'p3AMeFR',
                        outputParameter: 'project.building.buildingType',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: 'ONE_FAMILY_HOUSE'
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.buildingType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'buildingType'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'KmSj8LT',
                        outputParameter: 'project.building.currentHeatingSystem.currentHeaterAsPeakLoadDevice',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.currentHeaterAsPeakLoadDevice',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeaterAsPeakLoadDevice'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'lLhPFca',
                        outputParameter: 'project.building.warmWaterByHeatGenerator',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: true
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.warmWaterByHeatGenerator',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'warmWaterByHeatGenerator'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [
                {
                    id: 'dN3NSlA',
                    logicalCondition: {
                        and: [
                            {
                                '!=': [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'variables.interestsHeating.length',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'variables'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'interestsHeating'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'length'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    0
                                ]
                            },
                            {
                                '!=': [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'variables.interestsPV.length',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'variables'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'interestsPV'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'length'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    0
                                ]
                            }
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.4248e3c8-8343-4a98-acdb-8dfafbe3b73a.VALIDATIONS.dN3NSlA.ERROR_MESSAGE'
                }
            ],
            titleKey: 'QUESTION_FLOW.QUESTIONS.4248e3c8-8343-4a98-acdb-8dfafbe3b73a.TITLE',
            headerKey: 'QUESTION_FLOW.QUESTIONS.4248e3c8-8343-4a98-acdb-8dfafbe3b73a.HEADER',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '8b5b392a-8cfd-48ed-9a37-0eff67639be6',
            inputParameters: [
                {
                    parameter: 'variables.interestsHeating.length',
                    type: 'OBJECT'
                },
                {
                    parameter: 'variables.interestsPV.length',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.TARGET_INSTALLATION_SYSTEMS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.TARGET_INSTALLATION_SYSTEMS',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.initialEndCustomerInterest.heating',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.TARGET_INSTALLATION_SYSTEMS',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.TARGET_INSTALLATION_SYSTEMS.selectedItems',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.TARGET_INSTALLATION_SYSTEMS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.projectType',
                    type: 'STRING'
                },
                {
                    parameter: 'project.building.buildingType',
                    type: 'STRING'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.currentHeaterAsPeakLoadDevice',
                    type: 'BOOLEAN'
                },
                {
                    parameter: 'project.building.warmWaterByHeatGenerator',
                    type: 'BOOLEAN'
                }
            ]
        },
        '56cf9f33-230c-4037-a1c6-d62ee223b8c1': {
            id: 'cea23514-36ec-4b22-ac48-1d53dcb94b3a',
            name: 'Number of people',
            blockType: 'SUB_SECTION_BLOCK',
            isVirtual: false,
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.cea23514-36ec-4b22-ac48-1d53dcb94b3a.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '56cf9f33-230c-4037-a1c6-d62ee223b8c1',
            inputParameters: [],
            outputParameters: []
        },
        'f48eab5a-e6aa-4281-901b-e883740eabd5': {
            id: '0a886e8f-a391-4e1e-8494-3cd1657cd860',
            name: 'Building - Number of persons',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'jxDmWDe',
                        outputParameter: 'project.building.numberOfPersons',
                        outputParameterType: 'NUMBER',
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.0a886e8f-a391-4e1e-8494-3cd1657cd860.SLOTS.jxDmWDe.TITLE',
                        validations: [
                            {
                                id: 'LTvPv3g',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.numberOfPersons',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'numberOfPersons'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.0a886e8f-a391-4e1e-8494-3cd1657cd860.SLOTS.jxDmWDe.VALIDATIONS.LTvPv3g.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        numericMin: 1,
                        numericStep: 1,
                        numericMax: 15,
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.numberOfPersons',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'numberOfPersons'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            titleKey: 'QUESTION_FLOW.QUESTIONS.0a886e8f-a391-4e1e-8494-3cd1657cd860.TITLE',
            validations: [],
            headerKey: 'QUESTION_FLOW.QUESTIONS.0a886e8f-a391-4e1e-8494-3cd1657cd860.HEADER',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'f48eab5a-e6aa-4281-901b-e883740eabd5',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.numberOfPersons',
                    type: 'NUMBER'
                }
            ]
        },
        '0af1463c-3b13-4513-affc-55d90fbb2d5e': {
            id: 'a92eeda9-2edd-4c71-b155-cf4067b329b2',
            name: 'ZIP + City',
            blockType: 'SUB_SECTION_BLOCK',
            isVirtual: false,
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.a92eeda9-2edd-4c71-b155-cf4067b329b2.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '0af1463c-3b13-4513-affc-55d90fbb2d5e',
            inputParameters: [],
            outputParameters: []
        },
        '7074125c-9008-4737-ab50-1e6497b00a93': {
            id: '8fc1939d-ec2a-4d1c-b884-8bc8b49805a9',
            name: 'Building - Zip + City',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'Faez632',
                        outputParameter: 'project.address.postalCode',
                        outputParameterType: 'STRING',
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                }
                            }
                        },
                        validations: [
                            {
                                id: '4S6fTkY',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.address.postalCode',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'address'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'postalCode'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.8fc1939d-ec2a-4d1c-b884-8bc8b49805a9.SLOTS.Faez632.VALIDATIONS.4S6fTkY.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        dataFormat: '5',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.8fc1939d-ec2a-4d1c-b884-8bc8b49805a9.SLOTS.Faez632.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.address.postalCode',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'address'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'postalCode'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'eTipa0V',
                        outputParameter: 'project.address.city',
                        outputParameterType: 'STRING',
                        validations: [
                            {
                                id: '3ymQIlX',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.address.city',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'address'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'city'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.8fc1939d-ec2a-4d1c-b884-8bc8b49805a9.SLOTS.eTipa0V.VALIDATIONS.3ymQIlX.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.8fc1939d-ec2a-4d1c-b884-8bc8b49805a9.SLOTS.eTipa0V.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.address.city',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'address'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'city'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            titleKey: 'QUESTION_FLOW.QUESTIONS.8fc1939d-ec2a-4d1c-b884-8bc8b49805a9.TITLE',
            validations: [],
            headerKey: 'QUESTION_FLOW.QUESTIONS.8fc1939d-ec2a-4d1c-b884-8bc8b49805a9.HEADER',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '7074125c-9008-4737-ab50-1e6497b00a93',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.address.postalCode',
                    type: 'STRING'
                },
                {
                    parameter: 'project.address.city',
                    type: 'STRING'
                }
            ]
        },
        'f7b76220-4b57-4ff0-a5fc-5df7896dc364': {
            id: 'a85ba46f-cddc-4ea9-981a-36450ed5160f',
            name: 'Subsidy',
            blockType: 'SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SECTIONS.a85ba46f-cddc-4ea9-981a-36450ed5160f.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'f7b76220-4b57-4ff0-a5fc-5df7896dc364',
            inputParameters: [],
            outputParameters: []
        },
        'c29e8d57-42a0-4309-9359-778ae2dd90d8': {
            id: '0cc5512a-1421-4fcb-be6c-a9b85494e928',
            name: 'Subsidy-related details of your heating system',
            blockType: 'SUB_SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.0cc5512a-1421-4fcb-be6c-a9b85494e928.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'c29e8d57-42a0-4309-9359-778ae2dd90d8',
            inputParameters: [],
            outputParameters: []
        },
        '61a689ac-a83a-422f-b996-55a053ab89b6': {
            id: 'a350b673-8ee3-4cc9-a27f-8b5c67b11e56',
            name: 'Current Heater - installation year',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'gnVwxVB',
                        outputParameter: 'project.building.currentHeatingSystem.installationConstructionYear',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'ZckRt7i',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.currentHeatingSystem.installationConstructionYear',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'currentHeatingSystem'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'installationConstructionYear'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.a350b673-8ee3-4cc9-a27f-8b5c67b11e56.SLOTS.gnVwxVB.VALIDATIONS.ZckRt7i.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.a350b673-8ee3-4cc9-a27f-8b5c67b11e56.SLOTS.gnVwxVB.TITLE',
                        pathPlaceholders: [],
                        dataFormat: '4',
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.installationConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'installationConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.a350b673-8ee3-4cc9-a27f-8b5c67b11e56.TITLE',
            headerKey: 'QUESTION_FLOW.QUESTIONS.a350b673-8ee3-4cc9-a27f-8b5c67b11e56.HEADER',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '61a689ac-a83a-422f-b996-55a053ab89b6',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.currentHeatingSystem.installationConstructionYear',
                    type: 'NUMBER'
                }
            ]
        },
        'e4e989d5-d742-41a9-85d0-1e4df3b0e204': {
            id: '6d94e2af-ebfb-4d0d-b56b-395542b9829e',
            name: 'Current heater - type',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_TILE_SLOT',
                        id: 'gbAvLSN',
                        outputParameter: 'variables.hg_type',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.HEAT_GENERATOR_TYPES.{{value}}.TITLE',
                        dataSource: 'HEAT_GENERATOR_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.HEAT_GENERATOR_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'HEAT_GENERATOR_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['GAS_BOILER', 'OIL_BOILER', 'WOOD_STOVE', 'HEAT_PUMP', 'ELECTRIC_HEATER']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.HEAT_GENERATOR_TYPES.selectedItem',
                        labelKey: 'DATA_SOURCES.HEAT_GENERATOR_TYPES.{{value}}.LABEL',
                        visual: {
                            visualType: 'ICON',
                            visualId: 'DATA_SOURCES.HEAT_GENERATOR_TYPES.{{value}}.ICON'
                        },
                        pathPlaceholders: [],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        and: [
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.heatingSystemType',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatingSystemType'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'SOLID_FUEL_BOILER'
                                                ]
                                            },
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.energySource',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'energySource'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'PELLET'
                                                ]
                                            }
                                        ]
                                    },
                                    'WOOD_STOVE',
                                    {
                                        and: [
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.heatingSystemType',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatingSystemType'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'ELECTRIC_HEATER'
                                                ]
                                            },
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.energySource',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'energySource'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'ELECTRICITY_HEATPUMP'
                                                ]
                                            }
                                        ]
                                    },
                                    'ELECTRIC_HEATER',
                                    {
                                        and: [
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.heatingSystemType',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatingSystemType'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'AIR_HEAT_PUMP'
                                                ]
                                            },
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.energySource',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'energySource'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'ELECTRICITY_HEATPUMP'
                                                ]
                                            }
                                        ]
                                    },
                                    'HEAT_PUMP',
                                    {
                                        and: [
                                            {
                                                in: [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.heatingSystemType',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatingSystemType'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    ['FAN_BOILER', 'CONDENSING_BOILER']
                                                ]
                                            },
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.energySource',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'energySource'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'GAS'
                                                ]
                                            }
                                        ]
                                    },
                                    'GAS_BOILER',
                                    {
                                        and: [
                                            {
                                                in: [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.heatingSystemType',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatingSystemType'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    ['FAN_BOILER', 'CONDENSING_BOILER']
                                                ]
                                            },
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'project.building.currentHeatingSystem.energySource',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'energySource'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'HEATING_OIL'
                                                ]
                                            }
                                        ]
                                    },
                                    'OIL_BOILER',
                                    null
                                ]
                            },
                            toParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        compiledOutputParameter: {
                            originalPath: 'variables.hg_type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'hg_type'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.6d94e2af-ebfb-4d0d-b56b-395542b9829e.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'e4e989d5-d742-41a9-85d0-1e4df3b0e204',
            inputParameters: [
                {
                    parameter: 'dataSources.HEAT_GENERATOR_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.HEAT_GENERATOR_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.heatingSystemType',
                    type: 'STRING'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.energySource',
                    type: 'STRING'
                }
            ],
            outputParameters: [
                {
                    parameter: 'variables.hg_type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.HEAT_GENERATOR_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.HEAT_GENERATOR_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.HEAT_GENERATOR_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        '3a5f22c4-f466-4f4a-87e3-a032d1d3f131': {
            id: 'fc8f122b-7232-45ce-85f9-938d49c0c15b',
            name: 'Household details',
            blockType: 'SUB_SECTION_BLOCK',
            isVirtual: false,
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.fc8f122b-7232-45ce-85f9-938d49c0c15b.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '3a5f22c4-f466-4f4a-87e3-a032d1d3f131',
            inputParameters: [],
            outputParameters: []
        },
        'f69011fd-76da-458f-94b8-125d71357355': {
            id: '83a051c6-24e4-4532-b444-996a3e8b27fd',
            name: 'Household - owner/income/residence/heater defective',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: '3ezDnhm',
                        outputParameter: 'project.building.household.isOwnerOfTheBuilding',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.83a051c6-24e4-4532-b444-996a3e8b27fd.SLOTS.3ezDnhm.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.household.isOwnerOfTheBuilding',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isOwnerOfTheBuilding'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: 'XTIp10F',
                        outputParameter: 'project.building.household.isOwnerMainResidence',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.83a051c6-24e4-4532-b444-996a3e8b27fd.SLOTS.XTIp10F.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.household.isOwnerMainResidence',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isOwnerMainResidence'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: 'ctjrl5o',
                        outputParameter: 'project.building.household.isIncomeLowForSubsidy',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.83a051c6-24e4-4532-b444-996a3e8b27fd.SLOTS.ctjrl5o.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.household.isIncomeLowForSubsidy',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isIncomeLowForSubsidy'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: 'BDpId67',
                        outputParameter: 'project.building.household.isOldHeatingSystemDefective',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: {
                            '==': [
                                'OIL_BOILER',
                                'ELECTRIC_HEATER',
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'Project.CurrentHeatingSystemHeatGeneratorType',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'Project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'CurrentHeatingSystemHeatGeneratorType'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                }
                            ]
                        },
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.83a051c6-24e4-4532-b444-996a3e8b27fd.SLOTS.BDpId67.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.household.isOldHeatingSystemDefective',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isOldHeatingSystemDefective'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.83a051c6-24e4-4532-b444-996a3e8b27fd.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'f69011fd-76da-458f-94b8-125d71357355',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.household.isOwnerOfTheBuilding',
                    type: 'BOOLEAN'
                },
                {
                    parameter: 'project.building.household.isOwnerMainResidence',
                    type: 'BOOLEAN'
                },
                {
                    parameter: 'project.building.household.isIncomeLowForSubsidy',
                    type: 'BOOLEAN'
                },
                {
                    parameter: 'project.building.household.isOldHeatingSystemDefective',
                    type: 'BOOLEAN'
                }
            ]
        },
        '1de5e561-8db4-4baf-914c-2d0130d46a07': {
            id: '1c9fa6f4-ea64-4841-8a9d-c9df8afc37cc',
            name: 'Heat load',
            blockType: 'SECTION_BLOCK',
            isVirtual: false,
            titleKey: 'QUESTION_FLOW.SECTIONS.1c9fa6f4-ea64-4841-8a9d-c9df8afc37cc.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '1de5e561-8db4-4baf-914c-2d0130d46a07',
            inputParameters: [],
            outputParameters: []
        },
        'd8e992c9-1b0a-4045-9e4e-ce0d84321d8d': {
            id: 'ecd6dbc1-ba9b-4768-979d-3d889d26c4ca',
            name: 'HL - Construction year',
            blockType: 'SUB_SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.ecd6dbc1-ba9b-4768-979d-3d889d26c4ca.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'd8e992c9-1b0a-4045-9e4e-ce0d84321d8d',
            inputParameters: [],
            outputParameters: []
        },
        '329df5cc-5520-4dcd-8045-243d0cd07918': {
            id: 'ae945323-2b64-4fe6-8061-014351c5331d',
            name: 'HL - Construction year',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'lVi2oti',
                        outputParameter: 'project.building.buildingConstructionYear',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'mhAZNSv',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.buildingConstructionYear',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'buildingConstructionYear'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.ae945323-2b64-4fe6-8061-014351c5331d.SLOTS.lVi2oti.VALIDATIONS.mhAZNSv.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1950,
                        numericStep: 1,
                        numericMax: 2050,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.ae945323-2b64-4fe6-8061-014351c5331d.SLOTS.lVi2oti.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.buildingConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'buildingConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.ae945323-2b64-4fe6-8061-014351c5331d.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '329df5cc-5520-4dcd-8045-243d0cd07918',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.buildingConstructionYear',
                    type: 'NUMBER'
                }
            ]
        },
        '2a62bbe1-bab0-4ddc-a1ef-ad1be261a34c': {
            id: 'ae800d95-0e91-4c80-b96e-20b2aa67dfbb',
            name: 'HL - Renovations',
            blockType: 'SUB_SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.ae800d95-0e91-4c80-b96e-20b2aa67dfbb.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '2a62bbe1-bab0-4ddc-a1ef-ad1be261a34c',
            inputParameters: [],
            outputParameters: []
        },
        '10ebc503-e240-4289-b022-752caf5385fd': {
            id: '9823c1ff-0b7e-48c9-90a7-da958a819c2b',
            name: 'HL - Renovations',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'OPTIONAL_NUMERIC_INPUT_TILE_SLOT',
                        id: 'lVYhLLD',
                        outputParameter: 'project.building.roofConstructionYear',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1950,
                        numericStep: 1,
                        numericMax: 2050,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.9823c1ff-0b7e-48c9-90a7-da958a819c2b.SLOTS.lVYhLLD.TITLE',
                        labelKey: 'QUESTION_FLOW.QUESTIONS.9823c1ff-0b7e-48c9-90a7-da958a819c2b.SLOTS.lVYhLLD.LABEL',
                        visual: {
                            visualType: 'ICON',
                            visualId: 'GENERIC.STATUS_SOLID_HOUSE_NORMAL'
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.roofConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'roofConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'OPTIONAL_NUMERIC_INPUT_TILE_SLOT',
                        id: 'YDTtrfm',
                        outputParameter: 'project.building.wallsConstructionYear',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'QUESTION_FLOW.QUESTIONS.9823c1ff-0b7e-48c9-90a7-da958a819c2b.SLOTS.YDTtrfm.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.9823c1ff-0b7e-48c9-90a7-da958a819c2b.SLOTS.YDTtrfm.TITLE',
                        pathPlaceholders: [],
                        visual: {
                            visualType: 'ICON',
                            visualId: 'GENERIC.WALLS'
                        },
                        dataFormat: '4',
                        compiledOutputParameter: {
                            originalPath: 'project.building.wallsConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'wallsConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'OPTIONAL_NUMERIC_INPUT_TILE_SLOT',
                        id: '4TvQYlL',
                        outputParameter: 'project.building.windowsConstructionYear',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        visual: {
                            visualType: 'ICON',
                            visualId: 'GENERIC.GEOFENCING_SOLID_HOME'
                        },
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.9823c1ff-0b7e-48c9-90a7-da958a819c2b.SLOTS.4TvQYlL.TITLE',
                        labelKey: 'QUESTION_FLOW.QUESTIONS.9823c1ff-0b7e-48c9-90a7-da958a819c2b.SLOTS.4TvQYlL.LABEL',
                        dataFormat: '4',
                        compiledOutputParameter: {
                            originalPath: 'project.building.windowsConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windowsConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.9823c1ff-0b7e-48c9-90a7-da958a819c2b.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '10ebc503-e240-4289-b022-752caf5385fd',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.roofConstructionYear',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.wallsConstructionYear',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.windowsConstructionYear',
                    type: 'NUMBER'
                }
            ]
        },
        'e4ccf346-e904-4bfd-92f0-5861aaa336a6': {
            id: '50c25cc3-eef8-403a-9f0b-cd0ad7908c0a',
            name: 'HL - Floor area',
            blockType: 'SUB_SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.50c25cc3-eef8-403a-9f0b-cd0ad7908c0a.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'e4ccf346-e904-4bfd-92f0-5861aaa336a6',
            inputParameters: [],
            outputParameters: []
        },
        'c0d43361-d6a6-4227-a539-de17b6de9f60': {
            id: 'bb3f91db-ecd7-4d40-bc49-f0f52b76f4f2',
            name: 'HL - Floor area',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'nzEWcQT',
                        outputParameter: 'project.building.livingArea',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'lvixuCl',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.livingArea',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'livingArea'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.bb3f91db-ecd7-4d40-bc49-f0f52b76f4f2.SLOTS.nzEWcQT.VALIDATIONS.lvixuCl.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 50,
                        numericStep: 20,
                        numericMax: 400,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.bb3f91db-ecd7-4d40-bc49-f0f52b76f4f2.SLOTS.nzEWcQT.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.bb3f91db-ecd7-4d40-bc49-f0f52b76f4f2.SLOTS.nzEWcQT.SUFFIX.CONTENT',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.livingArea',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'livingArea'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.bb3f91db-ecd7-4d40-bc49-f0f52b76f4f2.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'c0d43361-d6a6-4227-a539-de17b6de9f60',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.livingArea',
                    type: 'NUMBER'
                }
            ]
        },
        '55c15f48-e21b-4582-924c-1e8cc7075bae': {
            id: 'c7206d66-00e9-4bff-884b-5664edf41c3d',
            name: 'Mechanical ventilation',
            blockType: 'SUB_SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.c7206d66-00e9-4bff-884b-5664edf41c3d.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '55c15f48-e21b-4582-924c-1e8cc7075bae',
            inputParameters: [],
            outputParameters: []
        },
        'baa8d761-190b-4ce6-acbc-e38e328adca2': {
            id: 'efd6e26d-1fbd-4f2b-8c96-5f0e367fdf5a',
            name: 'Mechanical ventilation',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: 'llXbyHe',
                        outputParameter: 'project.building.hasVentilation',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.efd6e26d-1fbd-4f2b-8c96-5f0e367fdf5a.SLOTS.llXbyHe.TITLE',
                        pathPlaceholders: [],
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                '!!': [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        compiledOutputParameter: {
                            originalPath: 'project.building.hasVentilation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'hasVentilation'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.efd6e26d-1fbd-4f2b-8c96-5f0e367fdf5a.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'baa8d761-190b-4ce6-acbc-e38e328adca2',
            headerKey: 'QUESTION_FLOW.QUESTIONS.efd6e26d-1fbd-4f2b-8c96-5f0e367fdf5a.HEADER',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.hasVentilation',
                    type: 'BOOLEAN'
                }
            ]
        },
        'c4642284-151f-40b2-a082-5970a8c3b72b': {
            id: '0202c566-7d29-4e9a-894a-76a96556cea2',
            name: 'Heating details',
            blockType: 'SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SECTIONS.0202c566-7d29-4e9a-894a-76a96556cea2.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'c4642284-151f-40b2-a082-5970a8c3b72b',
            inputParameters: [],
            outputParameters: []
        },
        '103a0db3-44cd-4888-9efd-24caa5ad85ac': {
            id: '52d638a3-8e5b-4262-b1b6-f909da1b72b6',
            name: 'Heat delivery',
            blockType: 'SUB_SECTION_BLOCK',
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.52d638a3-8e5b-4262-b1b6-f909da1b72b6.TITLE',
            isVirtual: false,
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '103a0db3-44cd-4888-9efd-24caa5ad85ac',
            inputParameters: [],
            outputParameters: []
        },
        'c18b5db6-aead-47aa-acb4-3e5b7b6aab0b': {
            id: '53ae6c4f-2d85-47cb-9f2c-6b0d381bc029',
            name: 'Heat delivery',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_TILE_SLOT',
                        id: 'dRSE996',
                        outputParameter: 'project.building.heatingType',
                        outputParameterType: 'STRING',
                        validations: [
                            {
                                id: '1MGxn9S',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.heatingType',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'heatingType'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.53ae6c4f-2d85-47cb-9f2c-6b0d381bc029.SLOTS.dRSE996.VALIDATIONS.1MGxn9S.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        dataSource: 'HEATING_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.HEATING_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'HEATING_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.HEATING_TYPES.selectedItem',
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.HEATING_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.HEATING_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [],
                        visual: {
                            visualType: 'ICON',
                            visualId: 'DATA_SOURCES.HEATING_TYPES.{{value}}.ICON'
                        },
                        compiledOutputParameter: {
                            originalPath: 'project.building.heatingType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatingType'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.53ae6c4f-2d85-47cb-9f2c-6b0d381bc029.TITLE',
            headerKey: 'QUESTION_FLOW.QUESTIONS.53ae6c4f-2d85-47cb-9f2c-6b0d381bc029.HEADER',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'c18b5db6-aead-47aa-acb4-3e5b7b6aab0b',
            inputParameters: [
                {
                    parameter: 'dataSources.HEATING_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.HEATING_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.heatingType',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.HEATING_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.HEATING_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.HEATING_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        '7ae77373-35e7-4dbc-b068-c834e75762ad': {
            id: '10400305-75e4-4adf-9fd4-425b3f372910',
            name: 'Heating chedule',
            blockType: 'SUB_SECTION_BLOCK',
            isVirtual: false,
            titleKey: 'QUESTION_FLOW.SUBSECTIONS.10400305-75e4-4adf-9fd4-425b3f372910.TITLE',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '7ae77373-35e7-4dbc-b068-c834e75762ad',
            inputParameters: [],
            outputParameters: []
        },
        '03ee8c3d-05ba-40ee-bc89-d2ef7407be2e': {
            id: 'd8d5cd51-372f-4d05-8af2-889fe47659fd',
            name: 'Heating schedule',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: 'rJB167h',
                        outputParameter: 'project.building.consumptionProfileForHeating',
                        outputParameterType: 'STRING',
                        validations: [
                            {
                                id: 'kEZn7iy',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.consumptionProfileForHeating',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'consumptionProfileForHeating'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.d8d5cd51-372f-4d05-8af2-889fe47659fd.SLOTS.rJB167h.VALIDATIONS.kEZn7iy.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        dataSource: 'CONSUMPTION_PROFILES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.CONSUMPTION_PROFILES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'CONSUMPTION_PROFILES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['HEAT_WITH_NOCTURNAL_FALL', 'HEAT_WITH_DAY_AND_NOCTURNAL_FALL', 'HEATPUMP_MODE']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.CONSUMPTION_PROFILES.selectedItem',
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.CONSUMPTION_PROFILES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.CONSUMPTION_PROFILES.{{value}}.LABEL',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.consumptionProfileForHeating',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'consumptionProfileForHeating'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'lkLHJjr',
                        outputParameter: 'project.building.currentHeatingSystem.heatGeneratorPower',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        '<': [
                                            {
                                                '+': [
                                                    {
                                                        '*': [
                                                            {
                                                                '/': [
                                                                    {
                                                                        '*': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath:
                                                                                            'globalContext.project.building.livingArea',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'globalContext'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'project'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'building'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'livingArea'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                if: [
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            1950
                                                                                        ]
                                                                                    },
                                                                                    120,
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            1979
                                                                                        ]
                                                                                    },
                                                                                    100,
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            1995
                                                                                        ]
                                                                                    },
                                                                                    80,
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            2010
                                                                                        ]
                                                                                    },
                                                                                    60,
                                                                                    40
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    1000
                                                                ]
                                                            },
                                                            {
                                                                if: [
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'GAS_BOILER'
                                                                        ]
                                                                    },
                                                                    1.15,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'OIL_BOILER'
                                                                        ]
                                                                    },
                                                                    1.2,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'WOOD_STOVE'
                                                                        ]
                                                                    },
                                                                    1.1,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'HEAT_PUMP'
                                                                        ]
                                                                    },
                                                                    1,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'ELECTRIC_HEATER'
                                                                        ]
                                                                    },
                                                                    1,
                                                                    1
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        if: [
                                                            {
                                                                '<=': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath:
                                                                                    'globalContext.project.building.numberOfPersons',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'globalContext'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'project'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'building'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'numberOfPersons'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    2
                                                                ]
                                                            },
                                                            0.5,
                                                            {
                                                                '<=': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath:
                                                                                    'globalContext.project.building.numberOfPersons',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'globalContext'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'project'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'building'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'numberOfPersons'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    4
                                                                ]
                                                            },
                                                            1,
                                                            1.5
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                if: [
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'GAS_BOILER'
                                                        ]
                                                    },
                                                    8,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'OIL_BOILER'
                                                        ]
                                                    },
                                                    10,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'WOOD_STOVE'
                                                        ]
                                                    },
                                                    8,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'HEAT_PUMP'
                                                        ]
                                                    },
                                                    4,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'ELECTRIC_HEATER'
                                                        ]
                                                    },
                                                    4,
                                                    4
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '==': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.hg_type',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'hg_type'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'GAS_BOILER'
                                                ]
                                            },
                                            8,
                                            {
                                                '==': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.hg_type',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'hg_type'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'OIL_BOILER'
                                                ]
                                            },
                                            10,
                                            {
                                                '==': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.hg_type',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'hg_type'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'WOOD_STOVE'
                                                ]
                                            },
                                            8,
                                            {
                                                '==': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.hg_type',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'hg_type'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'HEAT_PUMP'
                                                ]
                                            },
                                            4,
                                            {
                                                '==': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.hg_type',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'hg_type'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    'ELECTRIC_HEATER'
                                                ]
                                            },
                                            4,
                                            4
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '>': [
                                                    {
                                                        '+': [
                                                            {
                                                                '*': [
                                                                    {
                                                                        '/': [
                                                                            {
                                                                                '*': [
                                                                                    {
                                                                                        flexiPath: [
                                                                                            {
                                                                                                originalPath:
                                                                                                    'globalContext.project.building.livingArea',
                                                                                                tokens: [
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'globalContext'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'project'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'building'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'livingArea'
                                                                                                    }
                                                                                                ],
                                                                                                dynamicSlots: []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        if: [
                                                                                            {
                                                                                                '<': [
                                                                                                    {
                                                                                                        flexiPath: [
                                                                                                            {
                                                                                                                originalPath:
                                                                                                                    'globalContext.project.building.buildingConstructionYear',
                                                                                                                tokens: [
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'globalContext'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'project'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'building'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'buildingConstructionYear'
                                                                                                                    }
                                                                                                                ],
                                                                                                                dynamicSlots: []
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    1950
                                                                                                ]
                                                                                            },
                                                                                            120,
                                                                                            {
                                                                                                '<': [
                                                                                                    {
                                                                                                        flexiPath: [
                                                                                                            {
                                                                                                                originalPath:
                                                                                                                    'globalContext.project.building.buildingConstructionYear',
                                                                                                                tokens: [
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'globalContext'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'project'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'building'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'buildingConstructionYear'
                                                                                                                    }
                                                                                                                ],
                                                                                                                dynamicSlots: []
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    1979
                                                                                                ]
                                                                                            },
                                                                                            100,
                                                                                            {
                                                                                                '<': [
                                                                                                    {
                                                                                                        flexiPath: [
                                                                                                            {
                                                                                                                originalPath:
                                                                                                                    'globalContext.project.building.buildingConstructionYear',
                                                                                                                tokens: [
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'globalContext'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'project'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'building'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'buildingConstructionYear'
                                                                                                                    }
                                                                                                                ],
                                                                                                                dynamicSlots: []
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    1995
                                                                                                ]
                                                                                            },
                                                                                            80,
                                                                                            {
                                                                                                '<': [
                                                                                                    {
                                                                                                        flexiPath: [
                                                                                                            {
                                                                                                                originalPath:
                                                                                                                    'globalContext.project.building.buildingConstructionYear',
                                                                                                                tokens: [
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'globalContext'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'project'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'building'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: 'PROP',
                                                                                                                        name: 'buildingConstructionYear'
                                                                                                                    }
                                                                                                                ],
                                                                                                                dynamicSlots: []
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    2010
                                                                                                ]
                                                                                            },
                                                                                            60,
                                                                                            40
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            1000
                                                                        ]
                                                                    },
                                                                    {
                                                                        if: [
                                                                            {
                                                                                '==': [
                                                                                    {
                                                                                        flexiPath: [
                                                                                            {
                                                                                                originalPath: 'variables.hg_type',
                                                                                                tokens: [
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'variables'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'hg_type'
                                                                                                    }
                                                                                                ],
                                                                                                dynamicSlots: []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    'GAS_BOILER'
                                                                                ]
                                                                            },
                                                                            1.15,
                                                                            {
                                                                                '==': [
                                                                                    {
                                                                                        flexiPath: [
                                                                                            {
                                                                                                originalPath: 'variables.hg_type',
                                                                                                tokens: [
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'variables'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'hg_type'
                                                                                                    }
                                                                                                ],
                                                                                                dynamicSlots: []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    'OIL_BOILER'
                                                                                ]
                                                                            },
                                                                            1.2,
                                                                            {
                                                                                '==': [
                                                                                    {
                                                                                        flexiPath: [
                                                                                            {
                                                                                                originalPath: 'variables.hg_type',
                                                                                                tokens: [
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'variables'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'hg_type'
                                                                                                    }
                                                                                                ],
                                                                                                dynamicSlots: []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    'WOOD_STOVE'
                                                                                ]
                                                                            },
                                                                            1.1,
                                                                            {
                                                                                '==': [
                                                                                    {
                                                                                        flexiPath: [
                                                                                            {
                                                                                                originalPath: 'variables.hg_type',
                                                                                                tokens: [
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'variables'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'hg_type'
                                                                                                    }
                                                                                                ],
                                                                                                dynamicSlots: []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    'HEAT_PUMP'
                                                                                ]
                                                                            },
                                                                            1,
                                                                            {
                                                                                '==': [
                                                                                    {
                                                                                        flexiPath: [
                                                                                            {
                                                                                                originalPath: 'variables.hg_type',
                                                                                                tokens: [
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'variables'
                                                                                                    },
                                                                                                    {
                                                                                                        kind: 'PROP',
                                                                                                        name: 'hg_type'
                                                                                                    }
                                                                                                ],
                                                                                                dynamicSlots: []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    'ELECTRIC_HEATER'
                                                                                ]
                                                                            },
                                                                            1,
                                                                            1
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                if: [
                                                                    {
                                                                        '<=': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath:
                                                                                            'globalContext.project.building.numberOfPersons',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'globalContext'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'project'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'building'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'numberOfPersons'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            2
                                                                        ]
                                                                    },
                                                                    0.5,
                                                                    {
                                                                        '<=': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath:
                                                                                            'globalContext.project.building.numberOfPersons',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'globalContext'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'project'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'building'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'numberOfPersons'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            4
                                                                        ]
                                                                    },
                                                                    1,
                                                                    1.5
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        if: [
                                                            {
                                                                '==': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath: 'variables.hg_type',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'variables'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'hg_type'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    'GAS_BOILER'
                                                                ]
                                                            },
                                                            40,
                                                            {
                                                                '==': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath: 'variables.hg_type',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'variables'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'hg_type'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    'OIL_BOILER'
                                                                ]
                                                            },
                                                            50,
                                                            {
                                                                '==': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath: 'variables.hg_type',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'variables'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'hg_type'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    'WOOD_STOVE'
                                                                ]
                                                            },
                                                            35,
                                                            {
                                                                '==': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath: 'variables.hg_type',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'variables'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'hg_type'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    'HEAT_PUMP'
                                                                ]
                                                            },
                                                            20,
                                                            {
                                                                '==': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath: 'variables.hg_type',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'variables'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'hg_type'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    'ELECTRIC_HEATER'
                                                                ]
                                                            },
                                                            24,
                                                            40
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                if: [
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'GAS_BOILER'
                                                        ]
                                                    },
                                                    40,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'OIL_BOILER'
                                                        ]
                                                    },
                                                    50,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'WOOD_STOVE'
                                                        ]
                                                    },
                                                    35,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'HEAT_PUMP'
                                                        ]
                                                    },
                                                    20,
                                                    {
                                                        '==': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'variables.hg_type',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'variables'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'hg_type'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            'ELECTRIC_HEATER'
                                                        ]
                                                    },
                                                    24,
                                                    40
                                                ]
                                            },
                                            {
                                                '+': [
                                                    {
                                                        '*': [
                                                            {
                                                                '/': [
                                                                    {
                                                                        '*': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath:
                                                                                            'globalContext.project.building.livingArea',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'globalContext'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'project'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'building'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'livingArea'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                if: [
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            1950
                                                                                        ]
                                                                                    },
                                                                                    120,
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            1979
                                                                                        ]
                                                                                    },
                                                                                    100,
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            1995
                                                                                        ]
                                                                                    },
                                                                                    80,
                                                                                    {
                                                                                        '<': [
                                                                                            {
                                                                                                flexiPath: [
                                                                                                    {
                                                                                                        originalPath:
                                                                                                            'globalContext.project.building.buildingConstructionYear',
                                                                                                        tokens: [
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'globalContext'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'project'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'building'
                                                                                                            },
                                                                                                            {
                                                                                                                kind: 'PROP',
                                                                                                                name: 'buildingConstructionYear'
                                                                                                            }
                                                                                                        ],
                                                                                                        dynamicSlots: []
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            2010
                                                                                        ]
                                                                                    },
                                                                                    60,
                                                                                    40
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    1000
                                                                ]
                                                            },
                                                            {
                                                                if: [
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'GAS_BOILER'
                                                                        ]
                                                                    },
                                                                    1.15,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'OIL_BOILER'
                                                                        ]
                                                                    },
                                                                    1.2,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'WOOD_STOVE'
                                                                        ]
                                                                    },
                                                                    1.1,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'HEAT_PUMP'
                                                                        ]
                                                                    },
                                                                    1,
                                                                    {
                                                                        '==': [
                                                                            {
                                                                                flexiPath: [
                                                                                    {
                                                                                        originalPath: 'variables.hg_type',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'variables'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'hg_type'
                                                                                            }
                                                                                        ],
                                                                                        dynamicSlots: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            'ELECTRIC_HEATER'
                                                                        ]
                                                                    },
                                                                    1,
                                                                    1
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        if: [
                                                            {
                                                                '<=': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath:
                                                                                    'globalContext.project.building.numberOfPersons',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'globalContext'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'project'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'building'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'numberOfPersons'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    2
                                                                ]
                                                            },
                                                            0.5,
                                                            {
                                                                '<=': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath:
                                                                                    'globalContext.project.building.numberOfPersons',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'globalContext'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'project'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'building'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'numberOfPersons'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: []
                                                                            }
                                                                        ]
                                                                    },
                                                                    4
                                                                ]
                                                            },
                                                            1,
                                                            1.5
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.heatGeneratorPower',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatGeneratorPower'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'RDoO88u',
                        outputParameter: 'project.building.currentHeatingSystem.heatPumpOperatingMode',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'HEAT_PUMP'
                                        ]
                                    },
                                    'MONOVALENT',
                                    null
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.heatPumpOperatingMode',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatPumpOperatingMode'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'GQOk17c',
                        outputParameter: 'project.building.currentHeatingSystem.heatingSystemType',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'WOOD_STOVE'
                                        ]
                                    },
                                    'SOLID_FUEL_BOILER',
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'ELECTRIC_HEATER'
                                        ]
                                    },
                                    'ELECTRIC_HEATER',
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'HEAT_PUMP'
                                        ]
                                    },
                                    'AIR_HEAT_PUMP',
                                    {
                                        in: [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            ['GAS_BOILER', 'OIL_BOILER']
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '<=': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'globalContext.project.building.currentHeatingSystem.installationConstructionYear',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'globalContext'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'currentHeatingSystem'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'installationConstructionYear'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    1990
                                                ]
                                            },
                                            'FAN_BOILER',
                                            'CONDENSING_BOILER'
                                        ]
                                    },
                                    null
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.heatingSystemType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatingSystemType'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: '9hVqkvQ',
                        outputParameter: 'project.building.currentHeatingSystem.energySource',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'WOOD_STOVE'
                                        ]
                                    },
                                    'PELLET',
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'ELECTRIC_HEATER'
                                        ]
                                    },
                                    'ELECTRICITY_HEATPUMP',
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'HEAT_PUMP'
                                        ]
                                    },
                                    'ELECTRICITY_HEATPUMP',
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'GAS_BOILER'
                                        ]
                                    },
                                    'GAS',
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'OIL_BOILER'
                                        ]
                                    },
                                    'HEATING_OIL',
                                    null
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.energySource',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'energySource'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'payuiBg',
                        outputParameter: 'project.building.electricityDemand',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: 2500
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.electricityDemand',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'electricityDemand'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'Q1YqMSZ',
                        outputParameter: 'project.building.flowTemperature',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'globalContext.project.building.heatingType',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'globalContext'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatingType'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'RADIATOR'
                                        ]
                                    },
                                    65,
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'globalContext.project.building.heatingType',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'globalContext'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatingType'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'UNDERFLOOR_HEATING'
                                        ]
                                    },
                                    35,
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'globalContext.project.building.heatingType',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'globalContext'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatingType'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'MIXED'
                                        ]
                                    },
                                    55,
                                    null
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.flowTemperature',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'flowTemperature'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'xfml9Hc',
                        outputParameter: 'project.building.currentHeatingSystem.customConsumption',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: true,
                        isInactive: true,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'WOOD_STOVE'
                                        ]
                                    },
                                    3.75,
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'ELECTRIC_HEATER'
                                        ]
                                    },
                                    18000,
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'HEAT_PUMP'
                                        ]
                                    },
                                    6000,
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'GAS_BOILER'
                                        ]
                                    },
                                    18000,
                                    {
                                        '===': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.hg_type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'hg_type'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            'OIL_BOILER'
                                        ]
                                    },
                                    1840,
                                    null
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.customConsumption',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'customConsumption'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.d8d5cd51-372f-4d05-8af2-889fe47659fd.TITLE',
            headerKey: 'QUESTION_FLOW.QUESTIONS.d8d5cd51-372f-4d05-8af2-889fe47659fd.HEADER',
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: '03ee8c3d-05ba-40ee-bc89-d2ef7407be2e',
            inputParameters: [
                {
                    parameter: 'dataSources.CONSUMPTION_PROFILES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.CONSUMPTION_PROFILES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.livingArea',
                    type: 'NUMBER'
                },
                {
                    parameter: 'globalContext.project.building.buildingConstructionYear',
                    type: 'NUMBER'
                },
                {
                    parameter: 'variables.hg_type',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.numberOfPersons',
                    type: 'NUMBER'
                },
                {
                    parameter: 'globalContext.project.building.currentHeatingSystem.installationConstructionYear',
                    type: 'NUMBER'
                },
                {
                    parameter: 'globalContext.project.building.heatingType',
                    type: 'STRING'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.consumptionProfileForHeating',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.CONSUMPTION_PROFILES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.CONSUMPTION_PROFILES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.CONSUMPTION_PROFILES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.heatGeneratorPower',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.heatPumpOperatingMode',
                    type: 'STRING'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.heatingSystemType',
                    type: 'STRING'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.energySource',
                    type: 'STRING'
                },
                {
                    parameter: 'project.building.electricityDemand',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.flowTemperature',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.customConsumption',
                    type: 'NUMBER'
                }
            ]
        },
        'de3858fa-f1e3-474a-885c-744f7ee63696': {
            id: 'df60e1ac-f63b-45af-bd9e-72f510c76a7c',
            name: 'Current HS - Fixes',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'OG5DttW',
                        outputParameter: 'project.building.currentHeatingSystem.annualHeatingCosts',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: 2300
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.annualHeatingCosts',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'annualHeatingCosts'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'l1EChNB',
                        outputParameter: 'project.building.currentHeatingSystem.annualElectricityCosts',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: 1400
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.annualElectricityCosts',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'annualElectricityCosts'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'tsmjHCe',
                        outputParameter: 'project.building.currentHeatingSystem.co2EmissionForHeating',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: 3800
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.co2EmissionForHeating',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'co2EmissionForHeating'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'UxM66uR',
                        outputParameter: 'project.building.currentHeatingSystem.co2EmissionForElectricity',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: 2000
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.co2EmissionForElectricity',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'co2EmissionForElectricity'
                                }
                            ],
                            dynamicSlots: []
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'NzlTJQZ',
                        outputParameter: 'project.building.currentHeatingSystem.co2EmissionTotal',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                '+': [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.currentHeatingSystem.co2EmissionForHeating',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'currentHeatingSystem'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'co2EmissionForHeating'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath:
                                                    'globalContext.project.building.currentHeatingSystem.co2EmissionForElectricity',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'currentHeatingSystem'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'co2EmissionForElectricity'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.currentHeatingSystem.co2EmissionTotal',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'co2EmissionTotal'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            flowId: '<flow-mongo-db-record-id>',
            flowBlockId: 'de3858fa-f1e3-474a-885c-744f7ee63696',
            inputParameters: [
                {
                    parameter: 'globalContext.project.building.currentHeatingSystem.co2EmissionForHeating',
                    type: 'NUMBER'
                },
                {
                    parameter: 'globalContext.project.building.currentHeatingSystem.co2EmissionForElectricity',
                    type: 'NUMBER'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.currentHeatingSystem.annualHeatingCosts',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.annualElectricityCosts',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.co2EmissionForHeating',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.co2EmissionForElectricity',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.currentHeatingSystem.co2EmissionTotal',
                    type: 'NUMBER'
                }
            ]
        }
    },
    flow: {
        _id: '<flow-mongo-db-record-id>',
        diagram: '<diagram-mongo-db-record-id>',
        version: {
            currentVersion: 1,
            changeHistory: []
        },
        type: 'QUESTION_FLOW',
        area: 'MAIN_QUESTION_FLOW',
        blocks: [
            {
                id: '5fbaaca6-5107-432e-a7fa-1dd00ac79727',
                definitionId: '9588f1b1-3c8a-4a23-a8ae-1ecd30906d79',
                order: 1,
                childIds: [
                    'c2b8d035-968f-44bc-bd21-c6ad1df98c49',
                    '56cf9f33-230c-4037-a1c6-d62ee223b8c1',
                    '0af1463c-3b13-4513-affc-55d90fbb2d5e'
                ],
                slots: []
            },
            {
                id: '1de5e561-8db4-4baf-914c-2d0130d46a07',
                definitionId: '1c9fa6f4-ea64-4841-8a9d-c9df8afc37cc',
                order: 2,
                childIds: [
                    'd8e992c9-1b0a-4045-9e4e-ce0d84321d8d',
                    '2a62bbe1-bab0-4ddc-a1ef-ad1be261a34c',
                    'e4ccf346-e904-4bfd-92f0-5861aaa336a6',
                    '55c15f48-e21b-4582-924c-1e8cc7075bae'
                ],
                slots: []
            },
            {
                id: 'd8e992c9-1b0a-4045-9e4e-ce0d84321d8d',
                definitionId: 'ecd6dbc1-ba9b-4768-979d-3d889d26c4ca',
                order: 3,
                parentId: '1de5e561-8db4-4baf-914c-2d0130d46a07',
                childIds: ['329df5cc-5520-4dcd-8045-243d0cd07918'],
                slots: []
            },
            {
                id: '2a62bbe1-bab0-4ddc-a1ef-ad1be261a34c',
                definitionId: 'ae800d95-0e91-4c80-b96e-20b2aa67dfbb',
                order: 4,
                parentId: '1de5e561-8db4-4baf-914c-2d0130d46a07',
                childIds: ['10ebc503-e240-4289-b022-752caf5385fd'],
                slots: []
            },
            {
                id: 'e4ccf346-e904-4bfd-92f0-5861aaa336a6',
                definitionId: '50c25cc3-eef8-403a-9f0b-cd0ad7908c0a',
                order: 5,
                parentId: '1de5e561-8db4-4baf-914c-2d0130d46a07',
                childIds: ['c0d43361-d6a6-4227-a539-de17b6de9f60'],
                slots: []
            },
            {
                id: '55c15f48-e21b-4582-924c-1e8cc7075bae',
                definitionId: 'c7206d66-00e9-4bff-884b-5664edf41c3d',
                order: 6,
                parentId: '1de5e561-8db4-4baf-914c-2d0130d46a07',
                childIds: ['baa8d761-190b-4ce6-acbc-e38e328adca2'],
                slots: []
            },
            {
                id: 'c2b8d035-968f-44bc-bd21-c6ad1df98c49',
                definitionId: '03663e41-b867-4b0e-97eb-7aaace9c9e59',
                order: 7,
                parentId: '5fbaaca6-5107-432e-a7fa-1dd00ac79727',
                childIds: ['8b5b392a-8cfd-48ed-9a37-0eff67639be6'],
                slots: []
            },
            {
                id: '56cf9f33-230c-4037-a1c6-d62ee223b8c1',
                definitionId: 'cea23514-36ec-4b22-ac48-1d53dcb94b3a',
                order: 8,
                parentId: '5fbaaca6-5107-432e-a7fa-1dd00ac79727',
                childIds: ['f48eab5a-e6aa-4281-901b-e883740eabd5'],
                slots: []
            },
            {
                id: '0af1463c-3b13-4513-affc-55d90fbb2d5e',
                definitionId: 'a92eeda9-2edd-4c71-b155-cf4067b329b2',
                order: 9,
                parentId: '5fbaaca6-5107-432e-a7fa-1dd00ac79727',
                childIds: ['7074125c-9008-4737-ab50-1e6497b00a93'],
                slots: []
            },
            {
                id: 'f7b76220-4b57-4ff0-a5fc-5df7896dc364',
                definitionId: 'a85ba46f-cddc-4ea9-981a-36450ed5160f',
                order: 10,
                childIds: ['c29e8d57-42a0-4309-9359-778ae2dd90d8', '3a5f22c4-f466-4f4a-87e3-a032d1d3f131'],
                slots: []
            },
            {
                id: 'c29e8d57-42a0-4309-9359-778ae2dd90d8',
                definitionId: '0cc5512a-1421-4fcb-be6c-a9b85494e928',
                order: 11,
                parentId: 'f7b76220-4b57-4ff0-a5fc-5df7896dc364',
                childIds: ['e4e989d5-d742-41a9-85d0-1e4df3b0e204', '61a689ac-a83a-422f-b996-55a053ab89b6'],
                slots: []
            },
            {
                id: '3a5f22c4-f466-4f4a-87e3-a032d1d3f131',
                definitionId: 'fc8f122b-7232-45ce-85f9-938d49c0c15b',
                order: 12,
                parentId: 'f7b76220-4b57-4ff0-a5fc-5df7896dc364',
                childIds: ['f69011fd-76da-458f-94b8-125d71357355'],
                slots: []
            },
            {
                id: 'c4642284-151f-40b2-a082-5970a8c3b72b',
                definitionId: '0202c566-7d29-4e9a-894a-76a96556cea2',
                order: 13,
                childIds: ['7ae77373-35e7-4dbc-b068-c834e75762ad', '103a0db3-44cd-4888-9efd-24caa5ad85ac'],
                slots: []
            },
            {
                id: '7ae77373-35e7-4dbc-b068-c834e75762ad',
                definitionId: '10400305-75e4-4adf-9fd4-425b3f372910',
                order: 14,
                parentId: 'c4642284-151f-40b2-a082-5970a8c3b72b',
                childIds: ['03ee8c3d-05ba-40ee-bc89-d2ef7407be2e', 'de3858fa-f1e3-474a-885c-744f7ee63696'],
                slots: []
            },
            {
                id: '103a0db3-44cd-4888-9efd-24caa5ad85ac',
                definitionId: '52d638a3-8e5b-4262-b1b6-f909da1b72b6',
                order: 15,
                parentId: 'c4642284-151f-40b2-a082-5970a8c3b72b',
                childIds: ['c18b5db6-aead-47aa-acb4-3e5b7b6aab0b'],
                slots: []
            },
            {
                id: '329df5cc-5520-4dcd-8045-243d0cd07918',
                definitionId: 'ae945323-2b64-4fe6-8061-014351c5331d',
                order: 16,
                parentId: 'd8e992c9-1b0a-4045-9e4e-ce0d84321d8d',
                slots: [
                    {
                        slotId: 'lVi2oti',
                        compiledPath: {
                            originalPath: 'project.building.buildingConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'buildingConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['10ebc503-e240-4289-b022-752caf5385fd'],
                inputPaths: ['c0d43361-d6a6-4227-a539-de17b6de9f60']
            },
            {
                id: '10ebc503-e240-4289-b022-752caf5385fd',
                definitionId: '9823c1ff-0b7e-48c9-90a7-da958a819c2b',
                order: 17,
                parentId: '2a62bbe1-bab0-4ddc-a1ef-ad1be261a34c',
                slots: [
                    {
                        slotId: 'lVYhLLD',
                        compiledPath: {
                            originalPath: 'project.building.roofConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'roofConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'YDTtrfm',
                        compiledPath: {
                            originalPath: 'project.building.wallsConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'wallsConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: '4TvQYlL',
                        compiledPath: {
                            originalPath: 'project.building.windowsConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windowsConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                inputPaths: ['329df5cc-5520-4dcd-8045-243d0cd07918'],
                outputPaths: ['baa8d761-190b-4ce6-acbc-e38e328adca2']
            },
            {
                id: 'c0d43361-d6a6-4227-a539-de17b6de9f60',
                definitionId: 'bb3f91db-ecd7-4d40-bc49-f0f52b76f4f2',
                order: 18,
                parentId: 'e4ccf346-e904-4bfd-92f0-5861aaa336a6',
                slots: [
                    {
                        slotId: 'nzEWcQT',
                        compiledPath: {
                            originalPath: 'project.building.livingArea',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'livingArea'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['329df5cc-5520-4dcd-8045-243d0cd07918'],
                inputPaths: ['f69011fd-76da-458f-94b8-125d71357355']
            },
            {
                id: 'baa8d761-190b-4ce6-acbc-e38e328adca2',
                definitionId: 'efd6e26d-1fbd-4f2b-8c96-5f0e367fdf5a',
                order: 19,
                parentId: '55c15f48-e21b-4582-924c-1e8cc7075bae',
                slots: [
                    {
                        slotId: 'llXbyHe',
                        compiledPath: {
                            originalPath: 'project.building.hasVentilation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'hasVentilation'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                inputPaths: ['10ebc503-e240-4289-b022-752caf5385fd'],
                outputPaths: ['c18b5db6-aead-47aa-acb4-3e5b7b6aab0b']
            },
            {
                id: 'fbd8448a-ed5d-42e4-9d25-4092f150d5df',
                definitionId: '0',
                order: 20,
                slots: [],
                inputPaths: ['de3858fa-f1e3-474a-885c-744f7ee63696']
            },
            {
                id: '8b5b392a-8cfd-48ed-9a37-0eff67639be6',
                definitionId: '4248e3c8-8343-4a98-acdb-8dfafbe3b73a',
                order: 21,
                parentId: 'c2b8d035-968f-44bc-bd21-c6ad1df98c49',
                slots: [
                    {
                        slotId: 'Oi3ykiw',
                        compiledPath: {
                            originalPath: 'project.initialEndCustomerInterest.heating',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'initialEndCustomerInterest'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heating'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'diQVzBz',
                        compiledPath: {
                            originalPath: 'project.projectType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'projectType'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'p3AMeFR',
                        compiledPath: {
                            originalPath: 'project.building.buildingType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'buildingType'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'KmSj8LT',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.currentHeaterAsPeakLoadDevice',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeaterAsPeakLoadDevice'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'lLhPFca',
                        compiledPath: {
                            originalPath: 'project.building.warmWaterByHeatGenerator',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'warmWaterByHeatGenerator'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['f48eab5a-e6aa-4281-901b-e883740eabd5']
            },
            {
                id: 'f48eab5a-e6aa-4281-901b-e883740eabd5',
                definitionId: '0a886e8f-a391-4e1e-8494-3cd1657cd860',
                order: 22,
                parentId: '56cf9f33-230c-4037-a1c6-d62ee223b8c1',
                slots: [
                    {
                        slotId: 'jxDmWDe',
                        compiledPath: {
                            originalPath: 'project.building.numberOfPersons',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'numberOfPersons'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['8b5b392a-8cfd-48ed-9a37-0eff67639be6'],
                outputPaths: ['7074125c-9008-4737-ab50-1e6497b00a93']
            },
            {
                id: '7074125c-9008-4737-ab50-1e6497b00a93',
                definitionId: '8fc1939d-ec2a-4d1c-b884-8bc8b49805a9',
                order: 23,
                parentId: '0af1463c-3b13-4513-affc-55d90fbb2d5e',
                slots: [
                    {
                        slotId: 'Faez632',
                        compiledPath: {
                            originalPath: 'project.address.postalCode',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'address'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'postalCode'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'eTipa0V',
                        compiledPath: {
                            originalPath: 'project.address.city',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'address'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'city'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['f48eab5a-e6aa-4281-901b-e883740eabd5'],
                outputPaths: ['e4e989d5-d742-41a9-85d0-1e4df3b0e204']
            },
            {
                id: 'e4e989d5-d742-41a9-85d0-1e4df3b0e204',
                definitionId: '6d94e2af-ebfb-4d0d-b56b-395542b9829e',
                order: 24,
                parentId: 'c29e8d57-42a0-4309-9359-778ae2dd90d8',
                slots: [
                    {
                        slotId: 'gbAvLSN',
                        compiledPath: {
                            originalPath: 'variables.hg_type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'hg_type'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                inputPaths: ['7074125c-9008-4737-ab50-1e6497b00a93'],
                outputPaths: ['61a689ac-a83a-422f-b996-55a053ab89b6']
            },
            {
                id: '61a689ac-a83a-422f-b996-55a053ab89b6',
                definitionId: 'a350b673-8ee3-4cc9-a27f-8b5c67b11e56',
                order: 25,
                parentId: 'c29e8d57-42a0-4309-9359-778ae2dd90d8',
                slots: [
                    {
                        slotId: 'gnVwxVB',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.installationConstructionYear',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'installationConstructionYear'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                inputPaths: ['e4e989d5-d742-41a9-85d0-1e4df3b0e204'],
                outputPaths: ['f69011fd-76da-458f-94b8-125d71357355']
            },
            {
                id: 'f69011fd-76da-458f-94b8-125d71357355',
                definitionId: '83a051c6-24e4-4532-b444-996a3e8b27fd',
                order: 26,
                parentId: '3a5f22c4-f466-4f4a-87e3-a032d1d3f131',
                slots: [
                    {
                        slotId: '3ezDnhm',
                        compiledPath: {
                            originalPath: 'project.building.household.isOwnerOfTheBuilding',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isOwnerOfTheBuilding'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'XTIp10F',
                        compiledPath: {
                            originalPath: 'project.building.household.isOwnerMainResidence',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isOwnerMainResidence'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'ctjrl5o',
                        compiledPath: {
                            originalPath: 'project.building.household.isIncomeLowForSubsidy',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isIncomeLowForSubsidy'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'BDpId67',
                        compiledPath: {
                            originalPath: 'project.building.household.isOldHeatingSystemDefective',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'household'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isOldHeatingSystemDefective'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['c0d43361-d6a6-4227-a539-de17b6de9f60'],
                inputPaths: ['61a689ac-a83a-422f-b996-55a053ab89b6']
            },
            {
                id: '03ee8c3d-05ba-40ee-bc89-d2ef7407be2e',
                definitionId: 'd8d5cd51-372f-4d05-8af2-889fe47659fd',
                order: 27,
                parentId: '7ae77373-35e7-4dbc-b068-c834e75762ad',
                slots: [
                    {
                        slotId: 'rJB167h',
                        compiledPath: {
                            originalPath: 'project.building.consumptionProfileForHeating',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'consumptionProfileForHeating'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'lkLHJjr',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.heatGeneratorPower',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatGeneratorPower'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'RDoO88u',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.heatPumpOperatingMode',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatPumpOperatingMode'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'GQOk17c',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.heatingSystemType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatingSystemType'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: '9hVqkvQ',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.energySource',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'energySource'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'payuiBg',
                        compiledPath: {
                            originalPath: 'project.building.electricityDemand',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'electricityDemand'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'Q1YqMSZ',
                        compiledPath: {
                            originalPath: 'project.building.flowTemperature',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'flowTemperature'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'xfml9Hc',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.customConsumption',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'customConsumption'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['de3858fa-f1e3-474a-885c-744f7ee63696'],
                inputPaths: ['c18b5db6-aead-47aa-acb4-3e5b7b6aab0b']
            },
            {
                id: 'de3858fa-f1e3-474a-885c-744f7ee63696',
                definitionId: 'df60e1ac-f63b-45af-bd9e-72f510c76a7c',
                order: 28,
                parentId: '7ae77373-35e7-4dbc-b068-c834e75762ad',
                slots: [
                    {
                        slotId: 'OG5DttW',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.annualHeatingCosts',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'annualHeatingCosts'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'l1EChNB',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.annualElectricityCosts',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'annualElectricityCosts'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'tsmjHCe',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.co2EmissionForHeating',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'co2EmissionForHeating'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'UxM66uR',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.co2EmissionForElectricity',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'co2EmissionForElectricity'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'NzlTJQZ',
                        compiledPath: {
                            originalPath: 'project.building.currentHeatingSystem.co2EmissionTotal',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'currentHeatingSystem'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'co2EmissionTotal'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['fbd8448a-ed5d-42e4-9d25-4092f150d5df'],
                inputPaths: ['03ee8c3d-05ba-40ee-bc89-d2ef7407be2e']
            },
            {
                id: 'c18b5db6-aead-47aa-acb4-3e5b7b6aab0b',
                definitionId: '53ae6c4f-2d85-47cb-9f2c-6b0d381bc029',
                order: 29,
                parentId: '103a0db3-44cd-4888-9efd-24caa5ad85ac',
                slots: [
                    {
                        slotId: 'dRSE996',
                        compiledPath: {
                            originalPath: 'project.building.heatingType',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatingType'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['03ee8c3d-05ba-40ee-bc89-d2ef7407be2e'],
                inputPaths: ['baa8d761-190b-4ce6-acbc-e38e328adca2']
            }
        ],
        startingPoint: {
            blockId: '8b5b392a-8cfd-48ed-9a37-0eff67639be6',
            subsectionId: 'c2b8d035-968f-44bc-bd21-c6ad1df98c49',
            sectionId: '5fbaaca6-5107-432e-a7fa-1dd00ac79727'
        }
    },
    version: '2.0.0'
} as unknown as FrontendConfiguration;

export const RBR_CONFIGURATION = {
    name: '/!\\ Room By Room Official Flow',
    exportedAt: '2026-05-11T07:19:05.230Z',
    compiledFlowBlocks: {
        '8f913298-b467-4be9-82f2-30bccb6d2369': {
            id: 'c135a20c-2dfa-4faa-bc9d-42a947c9e6a1',
            name: 'Detailed Header INFO (workaround - not working)',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: []
            },
            validations: [],
            headerKey: 'QUESTION_FLOW.QUESTIONS.c135a20c-2dfa-4faa-bc9d-42a947c9e6a1.HEADER',
            footerKey: 'QUESTION_FLOW.QUESTIONS.c135a20c-2dfa-4faa-bc9d-42a947c9e6a1.FOOTER',
            flowBlockId: '8f913298-b467-4be9-82f2-30bccb6d2369',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: []
        },
        '4c4dae00-943b-4a9f-b506-b0b7dd40fabb': {
            id: '02de157a-c53d-46f1-b1b3-3dfe8cde7d37',
            name: 'Edit Room Section',
            blockType: 'SECTION_BLOCK',
            isVirtual: true,
            flowBlockId: '4c4dae00-943b-4a9f-b506-b0b7dd40fabb',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: []
        },
        'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49': {
            id: 'ff0eb470-0bd2-41b3-a6a6-cef549e08afb',
            name: 'Edit Room Main Sub-Section',
            blockType: 'SUB_SECTION_BLOCK',
            isVirtual: true,
            flowBlockId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: []
        },
        'ec4a09b2-0c63-4306-b933-a68c7bcda90e': {
            id: '04dd5eb8-46fe-48b0-b353-98de2e513718',
            name: 'Room Type/Level/FloorArea & ZoneId & SlabType (Slab 0)/Height',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'JyI2B',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.type',
                        outputParameterType: 'STRING',
                        validations: [
                            {
                                id: 'wMokS',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.rooms.{inputs.selectedRoomId}.type',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'rooms'
                                                        },
                                                        {
                                                            kind: 'DYNAMIC',
                                                            slot: 0,
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'type'
                                                        }
                                                    ],
                                                    dynamicSlots: [
                                                        {
                                                            expression: 'inputs.selectedRoomId',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'inputs'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'selectedRoomId'
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.JyI2B.VALIDATIONS.wMokS.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        dataSource: 'ROOM_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.ROOM_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'ROOM_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ROOM_TYPES.selectedItem',
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.ROOM_TYPES.{{value}}.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.JyI2B.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'ZrPXA',
                        outputParameter:
                            'project.building.levels.{ID(level):project.building.levels.{ID(level):project.building.rooms.{inputs.selectedRoomId}.levelIds.[0]}.id}.name',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: true,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.ZrPXA.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.levels.{ID(level):project.building.levels.{ID(level):project.building.rooms.{inputs.selectedRoomId}.levelIds.[0]}.id}.name',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'levels'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'level',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'levels'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'level',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'levelIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'name'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'ouho1',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'HOSvz',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath:
                                                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].area',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'slabs'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'slab',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'slabs'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'slab',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'rooms'
                                                                        },
                                                                        {
                                                                            kind: 'DYNAMIC',
                                                                            slot: 0,
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'slabIds'
                                                                        },
                                                                        {
                                                                            kind: 'INDEX',
                                                                            index: 0
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'id'
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'zones'
                                                        },
                                                        {
                                                            kind: 'INDEX',
                                                            index: 0
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'area'
                                                        }
                                                    ],
                                                    dynamicSlots: [
                                                        {
                                                            expression: 'inputs.selectedRoomId',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'inputs'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'selectedRoomId'
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.ouho1.VALIDATIONS.HOSvz.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericMax: 1000000,
                        dataFormat: '7',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.ouho1.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.ouho1.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'MSXBY',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.height',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: '0DwQW',
                                logicalCondition: {
                                    '!==': [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'project.building.rooms.{inputs.selectedRoomId}.height',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'rooms'
                                                        },
                                                        {
                                                            kind: 'DYNAMIC',
                                                            slot: 0,
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'height'
                                                        }
                                                    ],
                                                    dynamicSlots: [
                                                        {
                                                            expression: 'inputs.selectedRoomId',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'inputs'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'selectedRoomId'
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        null
                                    ]
                                },
                                errorMessageKey:
                                    'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.MSXBY.VALIDATIONS.0DwQW.ERROR_MESSAGE',
                                validationType: 'MANDATORY'
                            }
                        ],
                        isOptional: false,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericMax: 1000,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.MSXBY.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.SLOTS.MSXBY.SUFFIX.CONTENT',
                        pathPlaceholders: [],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        '>': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'value',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'value'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.buildingLevelHeight',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'buildingLevelHeight'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.height',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'height'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: '381c74a2-34d4-4943-b206-5628c54e54f8',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'FLOOR_ZONE'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'lr3Fm2f',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'FLOOR'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            footerKey: 'QUESTION_FLOW.QUESTIONS.04dd5eb8-46fe-48b0-b353-98de2e513718.FOOTER',
            flowBlockId: 'ec4a09b2-0c63-4306-b933-a68c7bcda90e',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ROOM_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ROOM_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.buildingLevelHeight',
                    type: 'NUMBER'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ROOM_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.levels.{ID(level):project.building.levels.{ID(level):project.building.rooms.{inputs.selectedRoomId}.levelIds.[0]}.id}.name',
                    type: 'STRING'
                },
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.height',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].id',
                    type: 'STRING'
                },
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.type',
                    type: 'STRING'
                }
            ]
        },
        '765f97c5-3bf3-440f-bb50-a253497cbd0a': {
            id: '5c9bb6a3-73e9-4d0d-88d5-e7fae0e2cdcc',
            name: 'Room Functions (Cooling/Heating)',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                },
                                {
                                    size: 1,
                                    alignment: 'START'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: 'zLyPQ',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.isCooled',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.5c9bb6a3-73e9-4d0d-88d5-e7fae0e2cdcc.SLOTS.zLyPQ.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.isCooled',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isCooled'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: '1biI6',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.isHeated',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.5c9bb6a3-73e9-4d0d-88d5-e7fae0e2cdcc.SLOTS.1biI6.TITLE',
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.isHeated',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isHeated'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.5c9bb6a3-73e9-4d0d-88d5-e7fae0e2cdcc.TITLE',
            flowBlockId: '765f97c5-3bf3-440f-bb50-a253497cbd0a',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.isCooled',
                    type: 'BOOLEAN'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.isHeated',
                    type: 'BOOLEAN'
                }
            ]
        },
        '889dcef7-9a61-4553-8531-434adb0b273e': {
            id: 'b95518c6-18f8-404a-b4ad-24fb19506968',
            name: 'Heat Sources 0 or None',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: 'kFOfN',
                    logicalCondition: {
                        '<': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'heatSourcesCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            1
                        ]
                    },
                    description: '0 or none heat sources'
                },
                {
                    id: '0nmXu',
                    description: '> 0'
                }
            ],
            flowBlockId: '889dcef7-9a61-4553-8531-434adb0b273e',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        '167c5486-042d-4c42-897b-41409947e39f': {
            id: '8c7a136e-382f-48ed-8932-208c21f2ece8',
            name: '[HEAT SOURCE 1] Device / Connected Load / Number',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'EXTLp',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ROOM_HEAT_SOURCE_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'ROOM_HEAT_SOURCE_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource0',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.ROOM_HEAT_SOURCE_TYPES.{{value}}.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.8c7a136e-382f-48ed-8932-208c21f2ece8.SLOTS.EXTLp.TITLE',
                        titleData: {
                            createObject: [
                                [
                                    'heatSourceLoad',
                                    {
                                        if: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource0.heatSourceLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'ROOM_HEAT_SOURCE_TYPES'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'roomSource0'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSourceLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource0.heatSourceLoad',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'ROOM_HEAT_SOURCE_TYPES'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'roomSource0'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSourceLoad'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            '--'
                                        ]
                                    }
                                ]
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'zSVzq',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].connectedLoad',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.01,
                        numericMax: 999999.99,
                        dataFormat: '6.2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.8c7a136e-382f-48ed-8932-208c21f2ece8.SLOTS.zSVzq.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.8c7a136e-382f-48ed-8932-208c21f2ece8.SLOTS.zSVzq.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'uUt7m',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].amount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericStep: 1,
                        numericMax: 1000,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.8c7a136e-382f-48ed-8932-208c21f2ece8.SLOTS.uUt7m.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [
                {
                    id: '1OZ30op',
                    logicalCondition: {
                        '!': [
                            {
                                and: [
                                    {
                                        or: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 0
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].connectedLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 0
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'connectedLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        '!': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSources'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 0
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'type'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.8c7a136e-382f-48ed-8932-208c21f2ece8.VALIDATIONS.1OZ30op.ERROR_MESSAGE'
                }
            ],
            titleKey: 'QUESTION_FLOW.QUESTIONS.8c7a136e-382f-48ed-8932-208c21f2ece8.TITLE',
            flowBlockId: '167c5486-042d-4c42-897b-41409947e39f',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].type',
                    type: 'STRING'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource0.heatSourceLoad',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource0',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].amount',
                    type: 'NUMBER'
                }
            ]
        },
        'd40da010-3bd9-43d0-afe9-721016a7920a': {
            id: '0d05f17c-d1f2-4ca6-bf7f-000093e6916c',
            name: 'Heat Sources > 1',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: '7gizp',
                    logicalCondition: {
                        '<=': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'heatSourcesCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            1
                        ]
                    },
                    description: '<= 1'
                },
                {
                    id: '458Lk',
                    description: '> 1'
                }
            ],
            flowBlockId: 'd40da010-3bd9-43d0-afe9-721016a7920a',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        'e1465c89-7692-40eb-b550-63bce3b73810': {
            id: '970ba7e9-7928-4133-8371-6169ecdaa952',
            name: '[HEAT SOURCE 2] Device / Connected Load / Number',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'sYTNZ',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ROOM_HEAT_SOURCE_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'ROOM_HEAT_SOURCE_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource1',
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                0
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.ROOM_HEAT_SOURCE_TYPES.{{value}}.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.970ba7e9-7928-4133-8371-6169ecdaa952.SLOTS.sYTNZ.TITLE',
                        titleData: {
                            createObject: [
                                [
                                    'heatSourceLoad',
                                    {
                                        if: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource1.heatSourceLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'ROOM_HEAT_SOURCE_TYPES'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'roomSource1'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSourceLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource1.heatSourceLoad',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'ROOM_HEAT_SOURCE_TYPES'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'roomSource1'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSourceLoad'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            '--'
                                        ]
                                    }
                                ]
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'QLrvr',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].connectedLoad',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                0
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.01,
                        numericMax: 999999.99,
                        dataFormat: '6.2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.970ba7e9-7928-4133-8371-6169ecdaa952.SLOTS.QLrvr.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.970ba7e9-7928-4133-8371-6169ecdaa952.SLOTS.QLrvr.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'IykMS',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].amount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                0
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericStep: 1,
                        numericMax: 1000,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.970ba7e9-7928-4133-8371-6169ecdaa952.SLOTS.IykMS.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [
                {
                    id: 'GwaWNDn',
                    logicalCondition: {
                        '!': [
                            {
                                and: [
                                    {
                                        or: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 1
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].connectedLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 1
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'connectedLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        '!': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSources'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 1
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'type'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.970ba7e9-7928-4133-8371-6169ecdaa952.VALIDATIONS.GwaWNDn.ERROR_MESSAGE'
                }
            ],
            titleKey: 'QUESTION_FLOW.QUESTIONS.970ba7e9-7928-4133-8371-6169ecdaa952.TITLE',
            flowBlockId: 'e1465c89-7692-40eb-b550-63bce3b73810',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].type',
                    type: 'STRING'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource1.heatSourceLoad',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource1',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].amount',
                    type: 'NUMBER'
                }
            ]
        },
        '3affb21c-8ee1-4094-8b54-5f302f3128b1': {
            id: '6b62dd2e-544c-4f45-bdc4-927cd30ce0a5',
            name: 'Heat Sources > 2',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: 'zWZiq',
                    logicalCondition: {
                        '<=': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'heatSourcesCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            2
                        ]
                    },
                    description: '<= 2'
                },
                {
                    id: 'nYmmx',
                    description: '> 2'
                }
            ],
            flowBlockId: '3affb21c-8ee1-4094-8b54-5f302f3128b1',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        'd4a9aabc-8dba-4278-a368-cd5b3a0c102b': {
            id: 'f9b286e4-1603-4856-85cc-065224fd16ad',
            name: '[HEAT SOURCE 3] Device / Connected Load / Number',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'dgf7J',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ROOM_HEAT_SOURCE_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'ROOM_HEAT_SOURCE_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource2',
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                1
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.ROOM_HEAT_SOURCE_TYPES.{{value}}.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.f9b286e4-1603-4856-85cc-065224fd16ad.SLOTS.dgf7J.TITLE',
                        titleData: {
                            createObject: [
                                [
                                    'heatSourceLoad',
                                    {
                                        if: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource2.heatSourceLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'ROOM_HEAT_SOURCE_TYPES'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'roomSource2'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSourceLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource2.heatSourceLoad',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'ROOM_HEAT_SOURCE_TYPES'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'roomSource2'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSourceLoad'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            '--'
                                        ]
                                    }
                                ]
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '2'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 2
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: '0o8X0',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].connectedLoad',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                1
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.01,
                        numericMax: 999999.99,
                        dataFormat: '6.2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.f9b286e4-1603-4856-85cc-065224fd16ad.SLOTS.0o8X0.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.f9b286e4-1603-4856-85cc-065224fd16ad.SLOTS.0o8X0.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '2'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 2
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'mlqcJ',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].amount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                1
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericStep: 1,
                        numericMax: 1000,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.f9b286e4-1603-4856-85cc-065224fd16ad.SLOTS.mlqcJ.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '2'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 2
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [
                {
                    id: 'NduxTNQ',
                    logicalCondition: {
                        '!': [
                            {
                                and: [
                                    {
                                        or: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 2
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].connectedLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 2
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'connectedLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        '!': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSources'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 2
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'type'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.f9b286e4-1603-4856-85cc-065224fd16ad.VALIDATIONS.NduxTNQ.ERROR_MESSAGE'
                }
            ],
            titleKey: 'QUESTION_FLOW.QUESTIONS.f9b286e4-1603-4856-85cc-065224fd16ad.TITLE',
            flowBlockId: 'd4a9aabc-8dba-4278-a368-cd5b3a0c102b',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].type',
                    type: 'STRING'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource2.heatSourceLoad',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource2',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].amount',
                    type: 'NUMBER'
                }
            ]
        },
        '69f0ea13-9d5f-45a3-acc2-aa4c9a139303': {
            id: '09bcf39d-3123-4068-a2b6-e344e76e812d',
            name: 'Heat Source > 3',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: '1Y1rR',
                    logicalCondition: {
                        '<=': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'heatSourcesCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            3
                        ]
                    },
                    description: '<= 3'
                },
                {
                    id: '7479V',
                    description: '> 3'
                }
            ],
            flowBlockId: '69f0ea13-9d5f-45a3-acc2-aa4c9a139303',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        '3b442e55-4dbc-485b-8018-3efe8ab38ed1': {
            id: '107e7c2b-82fc-4eff-8dd8-dfa9076a23a8',
            name: '[HEAT SOURCE 4] Device / Connected Load / Number',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'BAXUh',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ROOM_HEAT_SOURCE_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'ROOM_HEAT_SOURCE_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource3',
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                2
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.ROOM_HEAT_SOURCE_TYPES.{{value}}.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.107e7c2b-82fc-4eff-8dd8-dfa9076a23a8.SLOTS.BAXUh.TITLE',
                        titleData: {
                            createObject: [
                                [
                                    'heatSourceLoad',
                                    {
                                        if: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource3.heatSourceLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'ROOM_HEAT_SOURCE_TYPES'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'roomSource3'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSourceLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource3.heatSourceLoad',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'ROOM_HEAT_SOURCE_TYPES'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'roomSource3'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSourceLoad'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            '--'
                                        ]
                                    }
                                ]
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '3'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 3
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: '20QSM',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].connectedLoad',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                2
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.01,
                        numericMax: 999999.99,
                        dataFormat: '6.2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.107e7c2b-82fc-4eff-8dd8-dfa9076a23a8.SLOTS.20QSM.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.107e7c2b-82fc-4eff-8dd8-dfa9076a23a8.SLOTS.20QSM.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '3'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 3
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'rcAT6',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].amount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                2
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericStep: 1,
                        numericMax: 1000,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.107e7c2b-82fc-4eff-8dd8-dfa9076a23a8.SLOTS.rcAT6.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '3'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 3
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [
                {
                    id: 'Req5DmD',
                    logicalCondition: {
                        '!': [
                            {
                                and: [
                                    {
                                        or: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 3
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].connectedLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 3
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'connectedLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        '!': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSources'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 3
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'type'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.107e7c2b-82fc-4eff-8dd8-dfa9076a23a8.VALIDATIONS.Req5DmD.ERROR_MESSAGE'
                }
            ],
            titleKey: 'QUESTION_FLOW.QUESTIONS.107e7c2b-82fc-4eff-8dd8-dfa9076a23a8.TITLE',
            flowBlockId: '3b442e55-4dbc-485b-8018-3efe8ab38ed1',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].type',
                    type: 'STRING'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource3.heatSourceLoad',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource3',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].amount',
                    type: 'NUMBER'
                }
            ]
        },
        'feebea45-d272-4ef4-a992-d20db52c9de9': {
            id: '544d20ec-c5ce-426d-b18a-58f4247cb97b',
            name: 'Heat Sources > 4',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: '0sD6d',
                    logicalCondition: {
                        '<=': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'heatSourcesCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            4
                        ]
                    },
                    description: '<= 4'
                },
                {
                    id: 'lOw9g',
                    description: '> 4'
                }
            ],
            flowBlockId: 'feebea45-d272-4ef4-a992-d20db52c9de9',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        '3e76db6b-d9e0-498c-830e-1c0af5f72e5c': {
            id: '24328abf-54ce-4e2c-b802-5c8e63bda175',
            name: '[HEAT SOURCE 5] Device / Connected Load / Number',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: '703tf',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ROOM_HEAT_SOURCE_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'ROOM_HEAT_SOURCE_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource4',
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                3
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.ROOM_HEAT_SOURCE_TYPES.{{value}}.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.24328abf-54ce-4e2c-b802-5c8e63bda175.SLOTS.703tf.TITLE',
                        titleData: {
                            createObject: [
                                [
                                    'heatSourceLoad',
                                    {
                                        if: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource4.heatSourceLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'ROOM_HEAT_SOURCE_TYPES'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'roomSource4'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSourceLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource4.heatSourceLoad',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'ROOM_HEAT_SOURCE_TYPES'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'roomSource4'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSourceLoad'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            '--'
                                        ]
                                    }
                                ]
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '4'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 4
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'v7E7U',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].connectedLoad',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                3
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.01,
                        numericMax: 999999.99,
                        dataFormat: '6.2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.24328abf-54ce-4e2c-b802-5c8e63bda175.SLOTS.v7E7U.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.24328abf-54ce-4e2c-b802-5c8e63bda175.SLOTS.v7E7U.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '4'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 4
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: '0CGaq',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].amount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                3
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericStep: 1,
                        numericMax: 1000,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.24328abf-54ce-4e2c-b802-5c8e63bda175.SLOTS.0CGaq.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '4'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 4
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [
                {
                    id: 'jZVBCp9',
                    logicalCondition: {
                        '!': [
                            {
                                and: [
                                    {
                                        or: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 4
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].connectedLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 4
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'connectedLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        '!': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSources'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 4
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'type'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.24328abf-54ce-4e2c-b802-5c8e63bda175.VALIDATIONS.jZVBCp9.ERROR_MESSAGE'
                }
            ],
            titleKey: 'QUESTION_FLOW.QUESTIONS.24328abf-54ce-4e2c-b802-5c8e63bda175.TITLE',
            flowBlockId: '3e76db6b-d9e0-498c-830e-1c0af5f72e5c',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].type',
                    type: 'STRING'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource4.heatSourceLoad',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource4',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].amount',
                    type: 'NUMBER'
                }
            ]
        },
        '3b187ebf-d639-4664-a24b-69965ac7ca1e': {
            id: 'f9f40024-2a79-420a-8700-cd2df683f552',
            name: 'Heat Sources > 5',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: 'IbpSc',
                    logicalCondition: {
                        '<=': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'heatSourcesCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            5
                        ]
                    },
                    description: '<= 5'
                },
                {
                    id: 'RIDa0',
                    description: '> 5'
                }
            ],
            flowBlockId: '3b187ebf-d639-4664-a24b-69965ac7ca1e',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        '0ecd4146-580b-4780-83c7-37a8369bffea': {
            id: 'd6f914d4-c160-4646-be44-bc03f406a57d',
            name: '[HEAT SOURCE 6] Device / Connected Load / Number',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'rWQGX',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ROOM_HEAT_SOURCE_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'ROOM_HEAT_SOURCE_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource5',
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                4
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.ROOM_HEAT_SOURCE_TYPES.{{value}}.LABEL',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.d6f914d4-c160-4646-be44-bc03f406a57d.SLOTS.rWQGX.TITLE',
                        titleData: {
                            createObject: [
                                [
                                    'heatSourceLoad',
                                    {
                                        if: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource5.heatSourceLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'variables'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'ROOM_HEAT_SOURCE_TYPES'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'roomSource5'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSourceLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource5.heatSourceLoad',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'variables'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'ROOM_HEAT_SOURCE_TYPES'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'roomSource5'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSourceLoad'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            '--'
                                        ]
                                    }
                                ]
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '5'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 5
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'tMxih',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].connectedLoad',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                4
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.01,
                        numericMax: 999999.99,
                        dataFormat: '6.2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.d6f914d4-c160-4646-be44-bc03f406a57d.SLOTS.tMxih.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.d6f914d4-c160-4646-be44-bc03f406a57d.SLOTS.tMxih.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '5'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 5
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: '8Sn7o',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].amount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: {
                            '<=': [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'heatSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'length'
                                                }
                                            ],
                                            dynamicSlots: [
                                                {
                                                    expression: 'inputs.selectedRoomId',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'inputs'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'selectedRoomId'
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                4
                            ]
                        },
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericStep: 1,
                        numericMax: 1000,
                        dataFormat: '4',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.d6f914d4-c160-4646-be44-bc03f406a57d.SLOTS.8Sn7o.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '5'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 5
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [
                {
                    id: 'qASuxba',
                    logicalCondition: {
                        '!': [
                            {
                                and: [
                                    {
                                        or: [
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 5
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            },
                                            {
                                                '>': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].connectedLoad',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 5
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'connectedLoad'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        '!': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].type',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSources'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 5
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'type'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.d6f914d4-c160-4646-be44-bc03f406a57d.VALIDATIONS.qASuxba.ERROR_MESSAGE'
                }
            ],
            titleKey: 'QUESTION_FLOW.QUESTIONS.d6f914d4-c160-4646-be44-bc03f406a57d.TITLE',
            flowBlockId: '0ecd4146-580b-4780-83c7-37a8369bffea',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].type',
                    type: 'STRING'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource5.heatSourceLoad',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'variables.ROOM_HEAT_SOURCE_TYPES.roomSource5',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ROOM_HEAT_SOURCE_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].connectedLoad',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].amount',
                    type: 'NUMBER'
                }
            ]
        },
        'fa7d7073-c638-4f8d-81a7-4b4d8b9b38a5': {
            id: 'e2fb7a73-51cc-441c-84cb-1ea225e7b636',
            name: 'Walls >= 1',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: 'ACyk7',
                    logicalCondition: {
                        '<': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'wallsCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            1
                        ]
                    },
                    description: '< 1'
                },
                {
                    id: 'vCzWY',
                    description: '>= 1'
                }
            ],
            flowBlockId: 'fa7d7073-c638-4f8d-81a7-4b4d8b9b38a5',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        'ab2b14fa-c3cb-4c0d-8cac-f2b1fa4100f5': {
            id: 'f1b9840a-1fa0-480b-9ff9-84edd17713d5',
            name: '[WALL 2.a] Wall area + orientation',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: '3ZCF6',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 1000000,
                        dataFormat: '7.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.f1b9840a-1fa0-480b-9ff9-84edd17713d5.SLOTS.3ZCF6.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.f1b9840a-1fa0-480b-9ff9-84edd17713d5.SLOTS.3ZCF6.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'D2QqX',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.orientation',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'GEOGRAPHICAL_ORIENTATIONS',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'GEOGRAPHICAL_ORIENTATIONS'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.GEOGRAPHICAL_ORIENTATIONS.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.f1b9840a-1fa0-480b-9ff9-84edd17713d5.SLOTS.D2QqX.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'QsY6FMP',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'WALL_ZONE'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.f1b9840a-1fa0-480b-9ff9-84edd17713d5.TITLE',
            flowBlockId: 'ab2b14fa-c3cb-4c0d-8cac-f2b1fa4100f5',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.orientation',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].id',
                    type: 'STRING'
                }
            ]
        },
        'a808d997-db6f-4b61-a08f-cc53a51abb16': {
            id: 'cc8eb0f9-d0ec-47f0-abfb-69c8a6c9b8f3',
            name: '[HEAT SOURCES] Number stepper',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'kS9fr',
                        outputParameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        numericMin: 0,
                        numericStep: 1,
                        numericMax: 6,
                        dataFormat: '1',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.cc8eb0f9-d0ec-47f0-abfb-69c8a6c9b8f3.SLOTS.kS9fr.TITLE',
                        pathPlaceholders: [],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        '>': [
                                            {
                                                if: [
                                                    {
                                                        '===': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'value',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'value'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            null
                                                        ]
                                                    },
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'globalContext.project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'globalContext'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'heatSources'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'length'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'value',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'value'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'value',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'value'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    null
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath:
                                                            'globalContext.project.building.rooms.{inputs.selectedRoomId}.heatSources.length',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'globalContext'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'heatSources'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'length'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'value',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'value'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    0
                                ]
                            },
                            toParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        compiledOutputParameter: {
                            originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSourcesCount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.cc8eb0f9-d0ec-47f0-abfb-69c8a6c9b8f3.TITLE',
            footerKey: 'QUESTION_FLOW.QUESTIONS.cc8eb0f9-d0ec-47f0-abfb-69c8a6c9b8f3.FOOTER',
            flowBlockId: 'a808d997-db6f-4b61-a08f-cc53a51abb16',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                    type: 'NUMBER'
                }
            ]
        },
        '9778e1ae-4b1f-4db3-9766-02e241f2ffe8': {
            id: '51086802-eb24-41b8-9585-9eb6d1bbe5be',
            name: 'Ceiling bordering',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: 'nvQzO',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['ROOF', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.51086802-eb24-41b8-9585-9eb6d1bbe5be.TITLE',
            flowBlockId: '9778e1ae-4b1f-4db3-9766-02e241f2ffe8',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'aa9a06a3-7124-47b6-ac59-7588b5bfd209': {
            id: 'f3e467e1-3c44-4407-a0d4-a71e532aa2a0',
            name: 'Ceiling Area & ZoneId & SlabType (Slab 1)',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'oNcrN',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 1,
                        numericMax: 1000000,
                        dataFormat: '7',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.f3e467e1-3c44-4407-a0d4-a71e532aa2a0.SLOTS.oNcrN.SUFFIX.CONTENT',
                        titleKey: 'QUESTION_FLOW.QUESTIONS.f3e467e1-3c44-4407-a0d4-a71e532aa2a0.SLOTS.oNcrN.TITLE',
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'gqOka',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath:
                                                            'globalContext.project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0]',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'globalContext'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'slabs'
                                                            },
                                                            {
                                                                kind: 'ACTION',
                                                                actionType: 'ID',
                                                                category: 'slab',
                                                                targetTemplate: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'slabs'
                                                                    },
                                                                    {
                                                                        kind: 'ACTION',
                                                                        actionType: 'ID',
                                                                        category: 'slab',
                                                                        targetTemplate: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'project'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'building'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'rooms'
                                                                            },
                                                                            {
                                                                                kind: 'DYNAMIC',
                                                                                slot: 0,
                                                                                isIndex: false
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'slabIds'
                                                                            },
                                                                            {
                                                                                kind: 'INDEX',
                                                                                index: 1
                                                                            }
                                                                        ],
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'id'
                                                                    }
                                                                ],
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'zones'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 0
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            'CEILING_ZONE',
                                            null
                                        ]
                                    }
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'DX4wfSI',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'CEILING'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.f3e467e1-3c44-4407-a0d4-a71e532aa2a0.TITLE',
            flowBlockId: 'aa9a06a3-7124-47b6-ac59-7588b5bfd209',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: [
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].id',
                    type: 'STRING'
                },
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.type',
                    type: 'STRING'
                }
            ]
        },
        '7d4e4285-ff94-459e-97df-c9ea61d9de64': {
            id: '5a16e6b0-0749-4c77-a296-031078f3228b',
            name: 'Floor (bordering list, slab 0)',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: 'e8g67',
                        outputParameter:
                            'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['GROUND', 'RAISED_BOTTOM_SLAB', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'START'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.5a16e6b0-0749-4c77-a296-031078f3228b.TITLE',
            flowBlockId: '7d4e4285-ff94-459e-97df-c9ea61d9de64',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'b57c97ab-7a05-4d8f-9feb-62668e170451': {
            id: '29e0dd9b-5fc8-4dd2-8272-303d8de1d854',
            name: 'Walls >= 3',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: '4crxH',
                    logicalCondition: {
                        '<': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'wallsCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            3
                        ]
                    },
                    description: '< 3'
                },
                {
                    id: 'RuPBd',
                    description: '>= 3'
                }
            ],
            flowBlockId: 'b57c97ab-7a05-4d8f-9feb-62668e170451',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        '9144f909-1c6b-4355-b94d-0e1ae8818bc5': {
            id: '7d3eaefe-4611-4fae-a407-65d6a962ff92',
            name: '[WALL 3.a] Wall area + orientation',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'U3i0D',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 1000000,
                        dataFormat: '7.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.7d3eaefe-4611-4fae-a407-65d6a962ff92.SLOTS.U3i0D.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.7d3eaefe-4611-4fae-a407-65d6a962ff92.SLOTS.U3i0D.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'ayS6C',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.orientation',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'GEOGRAPHICAL_ORIENTATIONS',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'GEOGRAPHICAL_ORIENTATIONS'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.GEOGRAPHICAL_ORIENTATIONS.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.7d3eaefe-4611-4fae-a407-65d6a962ff92.SLOTS.ayS6C.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'nvtGKwG',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'WALL_ZONE'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.7d3eaefe-4611-4fae-a407-65d6a962ff92.TITLE',
            flowBlockId: '9144f909-1c6b-4355-b94d-0e1ae8818bc5',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.orientation',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].id',
                    type: 'STRING'
                }
            ]
        },
        'd8424341-f431-4c67-9049-0c8e6c4f2f83': {
            id: '9637aef7-13be-4d1c-b90f-eb78e32f3a1a',
            name: '[WALL 3.b] Wall type',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: 'lNwKd',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['EXTERNAL', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.9637aef7-13be-4d1c-b90f-eb78e32f3a1a.TITLE',
            flowBlockId: 'd8424341-f431-4c67-9049-0c8e6c4f2f83',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'f2ef24f9-c0f0-4791-b041-a3287c14037f': {
            id: '3f807407-54f3-49e4-b3d1-4c55af45bf5e',
            name: '[WALL 3.c] Window Area+type / Sun Protection',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'um6mt',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.area',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'zBJ0c',
                                logicalCondition: {
                                    if: [
                                        {
                                            '!==': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 2
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                null
                                            ]
                                        },
                                        {
                                            '>': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 2
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'windows'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'window',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'windows'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'window',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'walls'
                                                                                },
                                                                                {
                                                                                    kind: 'ACTION',
                                                                                    actionType: 'ID',
                                                                                    category: 'wall',
                                                                                    targetTemplate: [
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'project'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'building'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'walls'
                                                                                        },
                                                                                        {
                                                                                            kind: 'ACTION',
                                                                                            actionType: 'ID',
                                                                                            category: 'wall',
                                                                                            targetTemplate: [
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'project'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'building'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'rooms'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'DYNAMIC',
                                                                                                    slot: 0,
                                                                                                    isIndex: false
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'wallIds'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'INDEX',
                                                                                                    index: 2
                                                                                                }
                                                                                            ],
                                                                                            isIndex: false
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'id'
                                                                                        }
                                                                                    ],
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'windowIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 0
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        true
                                    ]
                                }
                            }
                        ],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 100,
                        dataFormat: '3.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.3f807407-54f3-49e4-b3d1-4c55af45bf5e.SLOTS.um6mt.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 2
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'RtvVd',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.3f807407-54f3-49e4-b3d1-4c55af45bf5e.SLOTS.RtvVd.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 2
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'PWp7P',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_SUN_PROTECTION_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_SUN_PROTECTION_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_SUN_PROTECTION_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.3f807407-54f3-49e4-b3d1-4c55af45bf5e.SLOTS.PWp7P.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 2
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            flowBlockId: 'f2ef24f9-c0f0-4791-b041-a3287c14037f',
            flowId: '<flow-mongo-db-record-id>',
            titleKey: 'QUESTION_FLOW.QUESTIONS.3f807407-54f3-49e4-b3d1-4c55af45bf5e.TITLE',
            inputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfWindow',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfSunProtection',
                    type: 'STRING'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'ddfe72d5-4cec-4997-8ed5-48a8e5edef01': {
            id: '51b381f0-3763-4b7e-85cf-0382fed82651',
            name: 'Walls >= 4',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: 'w3pKx',
                    logicalCondition: {
                        '<': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'wallsCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            4
                        ]
                    },
                    description: '< 4'
                },
                {
                    id: 'wbvHv',
                    description: '>= 4'
                }
            ],
            flowBlockId: 'ddfe72d5-4cec-4997-8ed5-48a8e5edef01',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        'cb6476d0-b430-469f-9a4f-b5a8286b7397': {
            id: '56003e72-c67c-4e79-9dc7-60c7ca403035',
            name: '[WALL 4.a] Wall area + orientation',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'MuLvM',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 1000000,
                        dataFormat: '7.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.56003e72-c67c-4e79-9dc7-60c7ca403035.SLOTS.MuLvM.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.56003e72-c67c-4e79-9dc7-60c7ca403035.SLOTS.MuLvM.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'uS8jU',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.orientation',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'GEOGRAPHICAL_ORIENTATIONS',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'GEOGRAPHICAL_ORIENTATIONS'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.GEOGRAPHICAL_ORIENTATIONS.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.56003e72-c67c-4e79-9dc7-60c7ca403035.SLOTS.uS8jU.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: '928JgVM',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'WALL_ZONE'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.56003e72-c67c-4e79-9dc7-60c7ca403035.TITLE',
            flowBlockId: 'cb6476d0-b430-469f-9a4f-b5a8286b7397',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.orientation',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].id',
                    type: 'STRING'
                }
            ]
        },
        'f3749180-a380-4ed4-a26a-cb55d68827f0': {
            id: 'db9fc88d-d439-492b-a43d-584bc4b5be23',
            name: '[WALL 4.b] Wall type',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: '2Slp3',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['EXTERNAL', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.db9fc88d-d439-492b-a43d-584bc4b5be23.TITLE',
            flowBlockId: 'f3749180-a380-4ed4-a26a-cb55d68827f0',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'aa60d304-7e3f-4114-a0e6-bab725c19742': {
            id: 'b8e291e0-711c-42d2-af35-ca62423a05a9',
            name: '[WALL 4.c] Window Area+type / Sun Protection',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'XYH7d',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.area',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: '1a6xl',
                                logicalCondition: {
                                    if: [
                                        {
                                            '!==': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 3
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                null
                                            ]
                                        },
                                        {
                                            '>': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 3
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'windows'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'window',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'windows'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'window',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'walls'
                                                                                },
                                                                                {
                                                                                    kind: 'ACTION',
                                                                                    actionType: 'ID',
                                                                                    category: 'wall',
                                                                                    targetTemplate: [
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'project'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'building'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'walls'
                                                                                        },
                                                                                        {
                                                                                            kind: 'ACTION',
                                                                                            actionType: 'ID',
                                                                                            category: 'wall',
                                                                                            targetTemplate: [
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'project'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'building'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'rooms'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'DYNAMIC',
                                                                                                    slot: 0,
                                                                                                    isIndex: false
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'wallIds'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'INDEX',
                                                                                                    index: 3
                                                                                                }
                                                                                            ],
                                                                                            isIndex: false
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'id'
                                                                                        }
                                                                                    ],
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'windowIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 0
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        true
                                    ]
                                }
                            }
                        ],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 100,
                        dataFormat: '3.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.b8e291e0-711c-42d2-af35-ca62423a05a9.SLOTS.XYH7d.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 3
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'bF0pJ',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.b8e291e0-711c-42d2-af35-ca62423a05a9.SLOTS.bF0pJ.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 3
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'nCswy',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_SUN_PROTECTION_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_SUN_PROTECTION_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_SUN_PROTECTION_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.b8e291e0-711c-42d2-af35-ca62423a05a9.SLOTS.nCswy.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 3
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            flowBlockId: 'aa60d304-7e3f-4114-a0e6-bab725c19742',
            flowId: '<flow-mongo-db-record-id>',
            titleKey: 'QUESTION_FLOW.QUESTIONS.b8e291e0-711c-42d2-af35-ca62423a05a9.TITLE',
            inputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfWindow',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfSunProtection',
                    type: 'STRING'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        '4b27e496-21b1-4a58-adc9-7a90e82d1f49': {
            id: '13655091-c342-43dd-adff-8cdf1dc6cfa2',
            name: 'Walls >= 5',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: 'mwo5N',
                    logicalCondition: {
                        '<': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'wallsCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            5
                        ]
                    },
                    description: '< 5'
                },
                {
                    id: 'Zwzzi',
                    description: '>= 5'
                }
            ],
            flowBlockId: '4b27e496-21b1-4a58-adc9-7a90e82d1f49',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        '1d31e0af-7922-4930-9e40-5cf654432b6b': {
            id: '2b81c2e6-b2d3-4bcc-82b7-bf4251eebdec',
            name: '[WALL 5.a] Wall area + orientation',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'vuoXU',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 1000000,
                        dataFormat: '7.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.2b81c2e6-b2d3-4bcc-82b7-bf4251eebdec.SLOTS.vuoXU.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.2b81c2e6-b2d3-4bcc-82b7-bf4251eebdec.SLOTS.vuoXU.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: '2EKW0',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.orientation',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'GEOGRAPHICAL_ORIENTATIONS',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'GEOGRAPHICAL_ORIENTATIONS'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.GEOGRAPHICAL_ORIENTATIONS.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.2b81c2e6-b2d3-4bcc-82b7-bf4251eebdec.SLOTS.2EKW0.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: 'cC062PP',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'WALL_ZONE'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.2b81c2e6-b2d3-4bcc-82b7-bf4251eebdec.TITLE',
            flowBlockId: '1d31e0af-7922-4930-9e40-5cf654432b6b',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.orientation',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].id',
                    type: 'STRING'
                }
            ]
        },
        '9d4551d1-df66-46ce-af25-5793767dbc72': {
            id: '522dc05f-5e4e-41a3-be9f-8a710bd101f2',
            name: '[WALL 5.b] Wall type',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: 'LBGaB',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['EXTERNAL', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.522dc05f-5e4e-41a3-be9f-8a710bd101f2.TITLE',
            flowBlockId: '9d4551d1-df66-46ce-af25-5793767dbc72',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'a73780be-9b50-486c-99cd-3acea3e98d27': {
            id: 'a5644f59-e974-45ca-a3ab-6553a38854b6',
            name: '[WALL 5.c] Window Area+type / Sun Protection',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'IflcM',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.area',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'ewHxr',
                                logicalCondition: {
                                    if: [
                                        {
                                            '!==': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 4
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                null
                                            ]
                                        },
                                        {
                                            '>': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 4
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'windows'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'window',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'windows'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'window',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'walls'
                                                                                },
                                                                                {
                                                                                    kind: 'ACTION',
                                                                                    actionType: 'ID',
                                                                                    category: 'wall',
                                                                                    targetTemplate: [
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'project'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'building'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'walls'
                                                                                        },
                                                                                        {
                                                                                            kind: 'ACTION',
                                                                                            actionType: 'ID',
                                                                                            category: 'wall',
                                                                                            targetTemplate: [
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'project'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'building'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'rooms'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'DYNAMIC',
                                                                                                    slot: 0,
                                                                                                    isIndex: false
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'wallIds'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'INDEX',
                                                                                                    index: 4
                                                                                                }
                                                                                            ],
                                                                                            isIndex: false
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'id'
                                                                                        }
                                                                                    ],
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'windowIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 0
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        true
                                    ]
                                }
                            }
                        ],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 100,
                        dataFormat: '3.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.a5644f59-e974-45ca-a3ab-6553a38854b6.SLOTS.IflcM.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 4
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'qMHVn',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.a5644f59-e974-45ca-a3ab-6553a38854b6.SLOTS.qMHVn.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 4
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'mw37V',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_SUN_PROTECTION_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_SUN_PROTECTION_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_SUN_PROTECTION_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.a5644f59-e974-45ca-a3ab-6553a38854b6.SLOTS.mw37V.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 4
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            flowBlockId: 'a73780be-9b50-486c-99cd-3acea3e98d27',
            flowId: '<flow-mongo-db-record-id>',
            titleKey: 'QUESTION_FLOW.QUESTIONS.a5644f59-e974-45ca-a3ab-6553a38854b6.TITLE',
            inputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfWindow',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        '7146f308-0c51-413c-9619-a4bf1eb76cab': {
            id: 'b7f99c2a-3e3d-415a-b956-5b78a975f55d',
            name: 'Walls >= 6',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: '5gY32',
                    logicalCondition: {
                        '<': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'wallsCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            6
                        ]
                    },
                    description: '< 6'
                },
                {
                    id: 'Hbv14',
                    description: '>= 6'
                }
            ],
            flowBlockId: '7146f308-0c51-413c-9619-a4bf1eb76cab',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        'ef775efb-7b0c-4407-9b5c-fcdb8e39d894': {
            id: '54f5455e-180c-4785-b010-9a2a57dc98bc',
            name: '[WALL 6.a] Wall area + orientation',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'y1mmy',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 1000000,
                        dataFormat: '7.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.54f5455e-180c-4785-b010-9a2a57dc98bc.SLOTS.y1mmy.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.54f5455e-180c-4785-b010-9a2a57dc98bc.SLOTS.y1mmy.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'ygIJy',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.orientation',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'GEOGRAPHICAL_ORIENTATIONS',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'GEOGRAPHICAL_ORIENTATIONS'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.GEOGRAPHICAL_ORIENTATIONS.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.54f5455e-180c-4785-b010-9a2a57dc98bc.SLOTS.ygIJy.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: 'rIyPjLE',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'WALL_ZONE'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.54f5455e-180c-4785-b010-9a2a57dc98bc.TITLE',
            flowBlockId: 'ef775efb-7b0c-4407-9b5c-fcdb8e39d894',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.orientation',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].id',
                    type: 'STRING'
                }
            ]
        },
        'da7ed407-a1b3-4ac4-b50a-d1f4882fe407': {
            id: '0100ad45-7715-425b-a2d2-b74b9252084a',
            name: '[WALL 6.b] Wall type',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: '7WrJq',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['EXTERNAL', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.0100ad45-7715-425b-a2d2-b74b9252084a.TITLE',
            flowBlockId: 'da7ed407-a1b3-4ac4-b50a-d1f4882fe407',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        '712ee9ce-c68f-4ba0-94ef-5ce16ca2d5b9': {
            id: 'b665afd1-addb-4df1-abc4-2334ac285d74',
            name: '[WALL 6.c] Window Area+type / Sun Protection',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: '7WAE7',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.area',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'MBFWG',
                                logicalCondition: {
                                    if: [
                                        {
                                            '!==': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 5
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                null
                                            ]
                                        },
                                        {
                                            '>': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 5
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'windows'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'window',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'windows'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'window',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'walls'
                                                                                },
                                                                                {
                                                                                    kind: 'ACTION',
                                                                                    actionType: 'ID',
                                                                                    category: 'wall',
                                                                                    targetTemplate: [
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'project'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'building'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'walls'
                                                                                        },
                                                                                        {
                                                                                            kind: 'ACTION',
                                                                                            actionType: 'ID',
                                                                                            category: 'wall',
                                                                                            targetTemplate: [
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'project'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'building'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'rooms'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'DYNAMIC',
                                                                                                    slot: 0,
                                                                                                    isIndex: false
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'wallIds'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'INDEX',
                                                                                                    index: 5
                                                                                                }
                                                                                            ],
                                                                                            isIndex: false
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'id'
                                                                                        }
                                                                                    ],
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'windowIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 0
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        true
                                    ]
                                }
                            }
                        ],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 100,
                        dataFormat: '3.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.b665afd1-addb-4df1-abc4-2334ac285d74.SLOTS.7WAE7.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 5
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'Wv3IO',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.b665afd1-addb-4df1-abc4-2334ac285d74.SLOTS.Wv3IO.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 5
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'SC5Qz',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_SUN_PROTECTION_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_SUN_PROTECTION_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_SUN_PROTECTION_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.b665afd1-addb-4df1-abc4-2334ac285d74.SLOTS.SC5Qz.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 5
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            flowBlockId: '712ee9ce-c68f-4ba0-94ef-5ce16ca2d5b9',
            flowId: '<flow-mongo-db-record-id>',
            titleKey: 'QUESTION_FLOW.QUESTIONS.b665afd1-addb-4df1-abc4-2334ac285d74.TITLE',
            inputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfWindow',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfSunProtection',
                    type: 'STRING'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'c905e918-677a-42e7-a53b-5c14fc46e88b': {
            id: '9b6d4a8a-8270-40ee-a9b2-fb2e06a14857',
            name: '[WALL 1.a] Wall area + orientation',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'WjRs9',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].area',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 1000000,
                        dataFormat: '7.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.9b6d4a8a-8270-40ee-a9b2-fb2e06a14857.SLOTS.WjRs9.TITLE',
                        suffixKey: 'QUESTION_FLOW.QUESTIONS.9b6d4a8a-8270-40ee-a9b2-fb2e06a14857.SLOTS.WjRs9.SUFFIX.CONTENT',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'L4XxJ',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.orientation',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'GEOGRAPHICAL_ORIENTATIONS',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'GEOGRAPHICAL_ORIENTATIONS'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.GEOGRAPHICAL_ORIENTATIONS.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.9b6d4a8a-8270-40ee-a9b2-fb2e06a14857.SLOTS.L4XxJ.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'TEXT_INPUT_SLOT',
                        id: '6IzyEz4',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].id',
                        outputParameterType: 'STRING',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: true,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        valueConverter: {
                            fromParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    'WALL_ZONE'
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.9b6d4a8a-8270-40ee-a9b2-fb2e06a14857.TITLE',
            flowBlockId: 'c905e918-677a-42e7-a53b-5c14fc46e88b',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.orientation',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.GEOGRAPHICAL_ORIENTATIONS.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].id',
                    type: 'STRING'
                }
            ]
        },
        'adf638fa-6b63-4ab9-a718-22574fd9c105': {
            id: 'efba94f7-d5c4-42a3-8f4f-4d919308e8ad',
            name: '[WALL 1.b] Wall type',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: '8RZaW',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['EXTERNAL', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.efba94f7-d5c4-42a3-8f4f-4d919308e8ad.TITLE',
            flowBlockId: 'adf638fa-6b63-4ab9-a718-22574fd9c105',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        '3fa70af6-5d0e-434d-b5e1-75dd17f15f37': {
            id: 'cafc66e8-2a92-46be-906e-00a1c899dbc9',
            name: 'Walls >= 2',
            blockType: 'DECISION_BLOCK',
            decisionPaths: [
                {
                    id: '7klRd',
                    logicalCondition: {
                        '<': [
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'rooms'
                                            },
                                            {
                                                kind: 'DYNAMIC',
                                                slot: 0,
                                                isIndex: false
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'wallsCount'
                                            }
                                        ],
                                        dynamicSlots: [
                                            {
                                                expression: 'inputs.selectedRoomId',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'inputs'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'selectedRoomId'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            2
                        ]
                    },
                    description: '< 2'
                },
                {
                    id: 'CEFAK',
                    description: '>= 2'
                }
            ],
            flowBlockId: '3fa70af6-5d0e-434d-b5e1-75dd17f15f37',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                    type: 'OBJECT'
                }
            ],
            outputParameters: []
        },
        '1e3be7e9-c949-419c-88a0-8fbdd79efd53': {
            id: '200163b8-16cb-4fc9-ade0-bbddac1cf0ed',
            name: '[WALLS] Number Stepper',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'gPAsx',
                        outputParameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                        outputParameterType: 'NUMBER',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0,
                        numericStep: 1,
                        numericMax: 6,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.200163b8-16cb-4fc9-ade0-bbddac1cf0ed.SLOTS.gPAsx.TITLE',
                        dataFormat: '1',
                        pathPlaceholders: [],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        '>': [
                                            {
                                                if: [
                                                    {
                                                        '===': [
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath: 'value',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'value'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: []
                                                                    }
                                                                ]
                                                            },
                                                            null
                                                        ]
                                                    },
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'globalContext.project.building.rooms.{globalContext.inputs.selectedRoomId}.wallIds.length',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'globalContext'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'wallIds'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'length'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'globalContext.inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'globalContext'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'value',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'value'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'value',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'value'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    null
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath:
                                                            'globalContext.project.building.rooms.{globalContext.inputs.selectedRoomId}.wallIds.length',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'globalContext'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'wallIds'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'length'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'globalContext.inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'globalContext'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'value',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'value'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    0
                                ]
                            },
                            toParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        compiledOutputParameter: {
                            originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'wallsCount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.200163b8-16cb-4fc9-ade0-bbddac1cf0ed.TITLE',
            flowBlockId: '1e3be7e9-c949-419c-88a0-8fbdd79efd53',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [],
            outputParameters: [
                {
                    parameter: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                    type: 'NUMBER'
                }
            ]
        },
        '82cd37ec-14d1-4a66-9724-ed99cf968054': {
            id: '0efc0c86-95c6-4d5c-85a7-630326a7259b',
            name: 'Human Heat Sources (2x Steppers)',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'Mfjon',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0]',
                        outputParameterType: 'OBJECT',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: {
                            '!': {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.showHumanHeatSources',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'showHumanHeatSources'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        isHidden: {
                            '!': {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.showHumanHeatSources',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'showHumanHeatSources'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        numericMin: 0,
                        numericStep: 1,
                        numericMax: 6,
                        dataFormat: '2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.0efc0c86-95c6-4d5c-85a7-630326a7259b.SLOTS.Mfjon.TITLE',
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'variables.showHumanHeatSources',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'variables'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'showHumanHeatSources'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'value.amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'value'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    null
                                                ]
                                            },
                                            0,
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'value.amount',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'value'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'amount'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    null
                                ]
                            },
                            toParameter: {
                                createObject: [
                                    ['connectedLoad', 0.08],
                                    [
                                        'amount',
                                        {
                                            if: [
                                                {
                                                    '!==': [
                                                        {
                                                            flexiPath: [
                                                                {
                                                                    originalPath: 'value',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'value'
                                                                        }
                                                                    ],
                                                                    dynamicSlots: []
                                                                }
                                                            ]
                                                        },
                                                        null
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath: 'value',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'value'
                                                                }
                                                            ],
                                                            dynamicSlots: []
                                                        }
                                                    ]
                                                },
                                                0
                                            ]
                                        }
                                    ],
                                    ['type', 'HUMAN_ADULT']
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0]',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'residents'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'NUMERIC_STEPPER_SLOT',
                        id: 'IB6vY',
                        outputParameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1]',
                        outputParameterType: 'OBJECT',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: {
                            '!': {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.showHumanHeatSources',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'showHumanHeatSources'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        isHidden: {
                            '!': {
                                flexiPath: [
                                    {
                                        originalPath: 'variables.showHumanHeatSources',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'variables'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'showHumanHeatSources'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        numericMin: 0,
                        numericStep: 1,
                        numericMax: {
                            flexiPath: [
                                {
                                    originalPath: 'project.building.numberOfPersons',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'numberOfPersons'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataFormat: '2',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.0efc0c86-95c6-4d5c-85a7-630326a7259b.SLOTS.IB6vY.TITLE',
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'variables.showHumanHeatSources',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'variables'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'showHumanHeatSources'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '===': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath: 'value.amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'value'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: []
                                                            }
                                                        ]
                                                    },
                                                    null
                                                ]
                                            },
                                            0,
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'value.amount',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'value'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'amount'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    null
                                ]
                            },
                            toParameter: {
                                createObject: [
                                    ['connectedLoad', 0.04],
                                    [
                                        'amount',
                                        {
                                            if: [
                                                {
                                                    '!==': [
                                                        {
                                                            flexiPath: [
                                                                {
                                                                    originalPath: 'value',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'value'
                                                                        }
                                                                    ],
                                                                    dynamicSlots: []
                                                                }
                                                            ]
                                                        },
                                                        null
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath: 'value',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'value'
                                                                }
                                                            ],
                                                            dynamicSlots: []
                                                        }
                                                    ]
                                                },
                                                0
                                            ]
                                        }
                                    ],
                                    ['type', 'HUMAN_CHILD_PRESCHOOL']
                                ]
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1]',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'residents'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [
                {
                    id: 'nvUkY',
                    logicalCondition: {
                        '>': [
                            {
                                '+': [
                                    {
                                        if: [
                                            {
                                                '!!': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'residents'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 0
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'residents'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 0
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'amount'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '!!': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'residents'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 1
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'residents'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 1
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'amount'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    }
                                ]
                            },
                            0
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.0efc0c86-95c6-4d5c-85a7-630326a7259b.VALIDATIONS.nvUkY.ERROR_MESSAGE'
                },
                {
                    id: 'hTHYf',
                    logicalCondition: {
                        '<=': [
                            {
                                '+': [
                                    {
                                        if: [
                                            {
                                                '!!': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'residents'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 0
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'residents'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 0
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'amount'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    },
                                    {
                                        if: [
                                            {
                                                '!!': [
                                                    {
                                                        flexiPath: [
                                                            {
                                                                originalPath:
                                                                    'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'project'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'building'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'rooms'
                                                                    },
                                                                    {
                                                                        kind: 'DYNAMIC',
                                                                        slot: 0,
                                                                        isIndex: false
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'residents'
                                                                    },
                                                                    {
                                                                        kind: 'INDEX',
                                                                        index: 1
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'amount'
                                                                    }
                                                                ],
                                                                dynamicSlots: [
                                                                    {
                                                                        expression: 'inputs.selectedRoomId',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'inputs'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'selectedRoomId'
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'project'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'building'
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'rooms'
                                                            },
                                                            {
                                                                kind: 'DYNAMIC',
                                                                slot: 0,
                                                                isIndex: false
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'residents'
                                                            },
                                                            {
                                                                kind: 'INDEX',
                                                                index: 1
                                                            },
                                                            {
                                                                kind: 'PROP',
                                                                name: 'amount'
                                                            }
                                                        ],
                                                        dynamicSlots: [
                                                            {
                                                                expression: 'inputs.selectedRoomId',
                                                                tokens: [
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'inputs'
                                                                    },
                                                                    {
                                                                        kind: 'PROP',
                                                                        name: 'selectedRoomId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    }
                                ]
                            },
                            {
                                flexiPath: [
                                    {
                                        originalPath: 'project.building.numberOfPersons',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'project'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'building'
                                            },
                                            {
                                                kind: 'PROP',
                                                name: 'numberOfPersons'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        ]
                    },
                    errorMessageData: {
                        createObject: [
                            [
                                'numberOfPersons',
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'project.building.numberOfPersons',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'numberOfPersons'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                }
                            ]
                        ]
                    },
                    errorMessageKey: 'QUESTION_FLOW.QUESTIONS.0efc0c86-95c6-4d5c-85a7-630326a7259b.VALIDATIONS.hTHYf.ERROR_MESSAGE'
                }
            ],
            flowBlockId: '82cd37ec-14d1-4a66-9724-ed99cf968054',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.numberOfPersons',
                    type: 'NUMBER'
                },
                {
                    parameter: 'variables.showHumanHeatSources',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0]',
                    type: 'OBJECT'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1]',
                    type: 'OBJECT'
                }
            ]
        },
        'd84d4798-70de-4b9f-8a93-e45175ca95d6': {
            id: '2f0d021b-351f-4421-bcc8-c4025bc3d973',
            name: 'Number of Residents / Human Heat Sources (checkbox)',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'CHECKBOX_INLINE_SLOT',
                        id: '1DWKl',
                        outputParameter: 'variables.showHumanHeatSources',
                        outputParameterType: 'BOOLEAN',
                        validations: [],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.2f0d021b-351f-4421-bcc8-c4025bc3d973.SLOTS.1DWKl.TITLE',
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        '!==': [
                                            {
                                                flexiPath: [
                                                    {
                                                        originalPath: 'value',
                                                        tokens: [
                                                            {
                                                                kind: 'PROP',
                                                                name: 'value'
                                                            }
                                                        ],
                                                        dynamicSlots: []
                                                    }
                                                ]
                                            },
                                            null
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        '>': [
                                            {
                                                '+': [
                                                    {
                                                        if: [
                                                            {
                                                                '!!': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath:
                                                                                    'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'project'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'building'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'rooms'
                                                                                    },
                                                                                    {
                                                                                        kind: 'DYNAMIC',
                                                                                        slot: 0,
                                                                                        isIndex: false
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'residents'
                                                                                    },
                                                                                    {
                                                                                        kind: 'INDEX',
                                                                                        index: 0
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'amount'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: [
                                                                                    {
                                                                                        expression: 'inputs.selectedRoomId',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'inputs'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'selectedRoomId'
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath:
                                                                            'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'project'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'building'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'rooms'
                                                                            },
                                                                            {
                                                                                kind: 'DYNAMIC',
                                                                                slot: 0,
                                                                                isIndex: false
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'residents'
                                                                            },
                                                                            {
                                                                                kind: 'INDEX',
                                                                                index: 0
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'amount'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: [
                                                                            {
                                                                                expression: 'inputs.selectedRoomId',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'inputs'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'selectedRoomId'
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            0
                                                        ]
                                                    },
                                                    {
                                                        if: [
                                                            {
                                                                '!!': [
                                                                    {
                                                                        flexiPath: [
                                                                            {
                                                                                originalPath:
                                                                                    'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'project'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'building'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'rooms'
                                                                                    },
                                                                                    {
                                                                                        kind: 'DYNAMIC',
                                                                                        slot: 0,
                                                                                        isIndex: false
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'residents'
                                                                                    },
                                                                                    {
                                                                                        kind: 'INDEX',
                                                                                        index: 1
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'amount'
                                                                                    }
                                                                                ],
                                                                                dynamicSlots: [
                                                                                    {
                                                                                        expression: 'inputs.selectedRoomId',
                                                                                        tokens: [
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'inputs'
                                                                                            },
                                                                                            {
                                                                                                kind: 'PROP',
                                                                                                name: 'selectedRoomId'
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                flexiPath: [
                                                                    {
                                                                        originalPath:
                                                                            'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                                                                        tokens: [
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'project'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'building'
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'rooms'
                                                                            },
                                                                            {
                                                                                kind: 'DYNAMIC',
                                                                                slot: 0,
                                                                                isIndex: false
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'residents'
                                                                            },
                                                                            {
                                                                                kind: 'INDEX',
                                                                                index: 1
                                                                            },
                                                                            {
                                                                                kind: 'PROP',
                                                                                name: 'amount'
                                                                            }
                                                                        ],
                                                                        dynamicSlots: [
                                                                            {
                                                                                expression: 'inputs.selectedRoomId',
                                                                                tokens: [
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'inputs'
                                                                                    },
                                                                                    {
                                                                                        kind: 'PROP',
                                                                                        name: 'selectedRoomId'
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            0
                                                        ]
                                                    }
                                                ]
                                            },
                                            0
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                flexiPath: [
                                    {
                                        originalPath: 'value',
                                        tokens: [
                                            {
                                                kind: 'PROP',
                                                name: 'value'
                                            }
                                        ],
                                        dynamicSlots: []
                                    }
                                ]
                            }
                        },
                        pathPlaceholders: [],
                        compiledOutputParameter: {
                            originalPath: 'variables.showHumanHeatSources',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'showHumanHeatSources'
                                }
                            ],
                            dynamicSlots: []
                        }
                    }
                ]
            },
            validations: [],
            footerKey: 'QUESTION_FLOW.QUESTIONS.2f0d021b-351f-4421-bcc8-c4025bc3d973.FOOTER',
            flowBlockId: 'd84d4798-70de-4b9f-8a93-e45175ca95d6',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0].amount',
                    type: 'NUMBER'
                },
                {
                    parameter: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1].amount',
                    type: 'NUMBER'
                }
            ],
            outputParameters: [
                {
                    parameter: 'variables.showHumanHeatSources',
                    type: 'BOOLEAN'
                }
            ]
        },
        'a20dcfc4-c156-4ee0-a1b0-a7866307c9e9': {
            id: 'd8007702-f4ff-4327-a17c-1e66515c582e',
            name: '[WALL 2.b] Wall type',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'RADIO_BUTTON_INLINE_SLOT',
                        id: 'rcyqO',
                        outputParameter:
                            'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].adjacentTo.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'ZONE_ADJACENT_TO_TYPES',
                        dataSourceMapping: {
                            filter: [
                                {
                                    flexiPath: [
                                        {
                                            originalPath: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                                            tokens: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'dataSources'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'ZONE_ADJACENT_TO_TYPES'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'items'
                                                }
                                            ],
                                            dynamicSlots: []
                                        }
                                    ]
                                },
                                {
                                    in: [
                                        {
                                            flexiPath: [
                                                {
                                                    originalPath: 'value',
                                                    tokens: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'value'
                                                        }
                                                    ],
                                                    dynamicSlots: []
                                                }
                                            ]
                                        },
                                        ['EXTERNAL', 'UNHEATED_ROOM']
                                    ]
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        },
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        titleKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.TITLE',
                        labelKey: 'DATA_SOURCES.ZONE_ADJACENT_TO_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ],
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            titleKey: 'QUESTION_FLOW.QUESTIONS.d8007702-f4ff-4327-a17c-1e66515c582e.TITLE',
            flowBlockId: 'a20dcfc4-c156-4ee0-a1b0-a7866307c9e9',
            flowId: '<flow-mongo-db-record-id>',
            inputParameters: [
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].adjacentTo.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.ZONE_ADJACENT_TO_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'b9cfed35-6423-48de-a86c-06d6a5b8488b': {
            id: '32cc9dce-ddc3-4638-bca4-f76c89f3c0c5',
            name: '[WALL 2.c] Window Area+type / Sun Protection',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'Bu3XJ',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'QbLXP',
                                logicalCondition: {
                                    if: [
                                        {
                                            '!==': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 1
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                null
                                            ]
                                        },
                                        {
                                            '>': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 1
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'windows'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'window',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'windows'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'window',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'walls'
                                                                                },
                                                                                {
                                                                                    kind: 'ACTION',
                                                                                    actionType: 'ID',
                                                                                    category: 'wall',
                                                                                    targetTemplate: [
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'project'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'building'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'walls'
                                                                                        },
                                                                                        {
                                                                                            kind: 'ACTION',
                                                                                            actionType: 'ID',
                                                                                            category: 'wall',
                                                                                            targetTemplate: [
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'project'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'building'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'rooms'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'DYNAMIC',
                                                                                                    slot: 0,
                                                                                                    isIndex: false
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'wallIds'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'INDEX',
                                                                                                    index: 1
                                                                                                }
                                                                                            ],
                                                                                            isIndex: false
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'id'
                                                                                        }
                                                                                    ],
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'windowIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 0
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        true
                                    ]
                                }
                            }
                        ],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 100,
                        dataFormat: '3.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.32cc9dce-ddc3-4638-bca4-f76c89f3c0c5.SLOTS.Bu3XJ.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 1
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'W2F3h',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.32cc9dce-ddc3-4638-bca4-f76c89f3c0c5.SLOTS.W2F3h.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 1
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'PDfTH',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_SUN_PROTECTION_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_SUN_PROTECTION_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_SUN_PROTECTION_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.32cc9dce-ddc3-4638-bca4-f76c89f3c0c5.SLOTS.PDfTH.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 1
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            flowBlockId: 'b9cfed35-6423-48de-a86c-06d6a5b8488b',
            flowId: '<flow-mongo-db-record-id>',
            titleKey: 'QUESTION_FLOW.QUESTIONS.32cc9dce-ddc3-4638-bca4-f76c89f3c0c5.TITLE',
            inputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfWindow',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfSunProtection',
                    type: 'STRING'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        },
        'db7ab855-2644-4499-936a-8d754f2fb5a5': {
            id: '7a0de79a-c572-4bb1-832e-90376a47f52d',
            name: '[WALL 1.c] Window Area+type / Sun Protection',
            blockType: 'QUESTION_BLOCK',
            template: {
                type: 'MULTI_SLOT_QUESTION_TEMPLATE',
                layout: {
                    breakpoints: {
                        xs: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        sm: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        md: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        lg: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        },
                        xl: {
                            columns: [
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                },
                                {
                                    size: 1,
                                    alignment: 'STRETCH'
                                }
                            ]
                        }
                    }
                },
                slots: [
                    {
                        type: 'NUMERIC_INPUT_SLOT',
                        id: 'gQbTp',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.area',
                        outputParameterType: 'NUMBER',
                        validations: [
                            {
                                id: 'u0vkc',
                                logicalCondition: {
                                    if: [
                                        {
                                            '!==': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 1
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                null
                                            ]
                                        },
                                        {
                                            '>': [
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'walls'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'wall',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'walls'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'wall',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'rooms'
                                                                                },
                                                                                {
                                                                                    kind: 'DYNAMIC',
                                                                                    slot: 0,
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'wallIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 1
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'zones'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    flexiPath: [
                                                        {
                                                            originalPath:
                                                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                                                            tokens: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'windows'
                                                                },
                                                                {
                                                                    kind: 'ACTION',
                                                                    actionType: 'ID',
                                                                    category: 'window',
                                                                    targetTemplate: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'project'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'building'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'windows'
                                                                        },
                                                                        {
                                                                            kind: 'ACTION',
                                                                            actionType: 'ID',
                                                                            category: 'window',
                                                                            targetTemplate: [
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'project'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'building'
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'walls'
                                                                                },
                                                                                {
                                                                                    kind: 'ACTION',
                                                                                    actionType: 'ID',
                                                                                    category: 'wall',
                                                                                    targetTemplate: [
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'project'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'building'
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'walls'
                                                                                        },
                                                                                        {
                                                                                            kind: 'ACTION',
                                                                                            actionType: 'ID',
                                                                                            category: 'wall',
                                                                                            targetTemplate: [
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'project'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'building'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'rooms'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'DYNAMIC',
                                                                                                    slot: 0,
                                                                                                    isIndex: false
                                                                                                },
                                                                                                {
                                                                                                    kind: 'PROP',
                                                                                                    name: 'wallIds'
                                                                                                },
                                                                                                {
                                                                                                    kind: 'INDEX',
                                                                                                    index: 1
                                                                                                }
                                                                                            ],
                                                                                            isIndex: false
                                                                                        },
                                                                                        {
                                                                                            kind: 'PROP',
                                                                                            name: 'id'
                                                                                        }
                                                                                    ],
                                                                                    isIndex: false
                                                                                },
                                                                                {
                                                                                    kind: 'PROP',
                                                                                    name: 'windowIds'
                                                                                },
                                                                                {
                                                                                    kind: 'INDEX',
                                                                                    index: 0
                                                                                }
                                                                            ],
                                                                            isIndex: false
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'id'
                                                                        }
                                                                    ],
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'area'
                                                                }
                                                            ],
                                                            dynamicSlots: [
                                                                {
                                                                    expression: 'inputs.selectedRoomId',
                                                                    tokens: [
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'inputs'
                                                                        },
                                                                        {
                                                                            kind: 'PROP',
                                                                            name: 'selectedRoomId'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        true
                                    ]
                                }
                            }
                        ],
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        numericMin: 0.1,
                        numericMax: 100,
                        dataFormat: '3.1',
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        titleKey: 'QUESTION_FLOW.QUESTIONS.7a0de79a-c572-4bb1-832e-90376a47f52d.SLOTS.gQbTp.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'bdjiZ',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.type',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfWindow',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfWindow'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.7a0de79a-c572-4bb1-832e-90376a47f52d.SLOTS.bdjiZ.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'DROP_DOWN_SLOT',
                        id: 'JS0MP',
                        outputParameter:
                            'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                        outputParameterType: 'STRING',
                        validations: [],
                        dataSource: 'WINDOW_SUN_PROTECTION_TYPES',
                        dataSourceMapping: {
                            flexiPath: [
                                {
                                    originalPath: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'dataSources'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'WINDOW_SUN_PROTECTION_TYPES'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'items'
                                        }
                                    ],
                                    dynamicSlots: []
                                }
                            ]
                        },
                        dataSourceSelectionOutput: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                        isOptional: true,
                        isDisabled: false,
                        isInactive: false,
                        isHidden: false,
                        layout: {
                            breakpoints: {
                                xs: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                sm: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                md: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                lg: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                },
                                xl: {
                                    columns: [
                                        {
                                            size: 1,
                                            alignment: 'STRETCH'
                                        }
                                    ]
                                }
                            }
                        },
                        labelKey: 'DATA_SOURCES.WINDOW_SUN_PROTECTION_TYPES.{{value}}.LABEL',
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ],
                        valueConverter: {
                            fromParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            },
                            toParameter: {
                                if: [
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'value',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'value'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    },
                                    {
                                        flexiPath: [
                                            {
                                                originalPath: 'globalContext.project.building.standardTypeOfSunProtection',
                                                tokens: [
                                                    {
                                                        kind: 'PROP',
                                                        name: 'globalContext'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'project'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'building'
                                                    },
                                                    {
                                                        kind: 'PROP',
                                                        name: 'standardTypeOfSunProtection'
                                                    }
                                                ],
                                                dynamicSlots: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        },
                        titleKey: 'QUESTION_FLOW.QUESTIONS.7a0de79a-c572-4bb1-832e-90376a47f52d.SLOTS.JS0MP.TITLE',
                        compiledOutputParameter: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            },
            validations: [],
            flowBlockId: 'db7ab855-2644-4499-936a-8d754f2fb5a5',
            flowId: '<flow-mongo-db-record-id>',
            titleKey: 'QUESTION_FLOW.QUESTIONS.7a0de79a-c572-4bb1-832e-90376a47f52d.TITLE',
            inputParameters: [
                {
                    parameter:
                        'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfWindow',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'globalContext.project.building.standardTypeOfSunProtection',
                    type: 'STRING'
                }
            ],
            outputParameters: [
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.area',
                    type: 'NUMBER'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.type',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_TYPES.items',
                    type: 'ARRAY'
                },
                {
                    parameter:
                        'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                    type: 'STRING'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.selectedItem',
                    type: 'OBJECT'
                },
                {
                    parameter: 'dataSources.WINDOW_SUN_PROTECTION_TYPES.items',
                    type: 'ARRAY'
                }
            ]
        }
    },
    flow: {
        _id: '<flow-mongo-db-record-id>',
        diagram: '<diagram-mongo-db-record-id>',
        version: {
            currentVersion: 1,
            changeHistory: []
        },
        type: 'QUESTION_FLOW',
        area: 'MAIN_QUESTION_FLOW',
        blocks: [
            {
                id: '4c4dae00-943b-4a9f-b506-b0b7dd40fabb',
                definitionId: '02de157a-c53d-46f1-b1b3-3dfe8cde7d37',
                order: 1,
                childIds: ['ed4ac50c-c7cc-4035-b41d-a06d89ae3b49'],
                slots: []
            },
            {
                id: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                definitionId: 'ff0eb470-0bd2-41b3-a6a6-cef549e08afb',
                order: 2,
                parentId: '4c4dae00-943b-4a9f-b506-b0b7dd40fabb',
                childIds: [
                    'ec4a09b2-0c63-4306-b933-a68c7bcda90e',
                    '765f97c5-3bf3-440f-bb50-a253497cbd0a',
                    '889dcef7-9a61-4553-8531-434adb0b273e',
                    '167c5486-042d-4c42-897b-41409947e39f',
                    'e1465c89-7692-40eb-b550-63bce3b73810',
                    '3affb21c-8ee1-4094-8b54-5f302f3128b1',
                    'd4a9aabc-8dba-4278-a368-cd5b3a0c102b',
                    '69f0ea13-9d5f-45a3-acc2-aa4c9a139303',
                    '3b442e55-4dbc-485b-8018-3efe8ab38ed1',
                    'feebea45-d272-4ef4-a992-d20db52c9de9',
                    '3e76db6b-d9e0-498c-830e-1c0af5f72e5c',
                    '3b187ebf-d639-4664-a24b-69965ac7ca1e',
                    'fa7d7073-c638-4f8d-81a7-4b4d8b9b38a5',
                    'a808d997-db6f-4b61-a08f-cc53a51abb16',
                    '9778e1ae-4b1f-4db3-9766-02e241f2ffe8',
                    'aa9a06a3-7124-47b6-ac59-7588b5bfd209',
                    '7d4e4285-ff94-459e-97df-c9ea61d9de64',
                    'c905e918-677a-42e7-a53b-5c14fc46e88b',
                    '1e3be7e9-c949-419c-88a0-8fbdd79efd53',
                    '82cd37ec-14d1-4a66-9724-ed99cf968054',
                    'd84d4798-70de-4b9f-8a93-e45175ca95d6',
                    '0ecd4146-580b-4780-83c7-37a8369bffea',
                    'd40da010-3bd9-43d0-afe9-721016a7920a',
                    'adf638fa-6b63-4ab9-a718-22574fd9c105',
                    '3fa70af6-5d0e-434d-b5e1-75dd17f15f37',
                    'ab2b14fa-c3cb-4c0d-8cac-f2b1fa4100f5',
                    'a20dcfc4-c156-4ee0-a1b0-a7866307c9e9',
                    'b57c97ab-7a05-4d8f-9feb-62668e170451',
                    '9144f909-1c6b-4355-b94d-0e1ae8818bc5',
                    'd8424341-f431-4c67-9049-0c8e6c4f2f83',
                    'f2ef24f9-c0f0-4791-b041-a3287c14037f',
                    'b9cfed35-6423-48de-a86c-06d6a5b8488b',
                    'db7ab855-2644-4499-936a-8d754f2fb5a5',
                    'ddfe72d5-4cec-4997-8ed5-48a8e5edef01',
                    'cb6476d0-b430-469f-9a4f-b5a8286b7397',
                    'f3749180-a380-4ed4-a26a-cb55d68827f0',
                    'aa60d304-7e3f-4114-a0e6-bab725c19742',
                    '4b27e496-21b1-4a58-adc9-7a90e82d1f49',
                    '1d31e0af-7922-4930-9e40-5cf654432b6b',
                    '9d4551d1-df66-46ce-af25-5793767dbc72',
                    'a73780be-9b50-486c-99cd-3acea3e98d27',
                    '7146f308-0c51-413c-9619-a4bf1eb76cab',
                    'ef775efb-7b0c-4407-9b5c-fcdb8e39d894',
                    'da7ed407-a1b3-4ac4-b50a-d1f4882fe407',
                    '712ee9ce-c68f-4ba0-94ef-5ce16ca2d5b9'
                ],
                slots: []
            },
            {
                id: '889dcef7-9a61-4553-8531-434adb0b273e',
                definitionId: 'b95518c6-18f8-404a-b4ad-24fb19506968',
                order: 3,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['689dcd68-5131-4bc0-acc1-d0fc656053cf', '167c5486-042d-4c42-897b-41409947e39f'],
                inputPaths: ['a808d997-db6f-4b61-a08f-cc53a51abb16']
            },
            {
                id: '689dcd68-5131-4bc0-acc1-d0fc656053cf',
                definitionId: '0',
                order: 4,
                slots: [],
                inputPaths: [
                    '889dcef7-9a61-4553-8531-434adb0b273e',
                    '3affb21c-8ee1-4094-8b54-5f302f3128b1',
                    '69f0ea13-9d5f-45a3-acc2-aa4c9a139303',
                    'feebea45-d272-4ef4-a992-d20db52c9de9',
                    '3b187ebf-d639-4664-a24b-69965ac7ca1e',
                    '0ecd4146-580b-4780-83c7-37a8369bffea',
                    'd40da010-3bd9-43d0-afe9-721016a7920a'
                ]
            },
            {
                id: 'ec4a09b2-0c63-4306-b933-a68c7bcda90e',
                definitionId: '04dd5eb8-46fe-48b0-b353-98de2e513718',
                order: 5,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'JyI2B',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: 'ZrPXA',
                        compiledPath: {
                            originalPath:
                                'project.building.levels.{ID(level):project.building.levels.{ID(level):project.building.rooms.{inputs.selectedRoomId}.levelIds.[0]}.id}.name',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'levels'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'level',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'levels'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'level',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'levelIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'name'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#LEVEL_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'ouho1',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'MSXBY',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.height',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'height'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: '381c74a2-34d4-4943-b206-5628c54e54f8',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'lr3Fm2f',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                outputPaths: ['765f97c5-3bf3-440f-bb50-a253497cbd0a']
            },
            {
                id: '765f97c5-3bf3-440f-bb50-a253497cbd0a',
                definitionId: '5c9bb6a3-73e9-4d0d-88d5-e7fae0e2cdcc',
                order: 6,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'zLyPQ',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.isCooled',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isCooled'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: []
                    },
                    {
                        slotId: '1biI6',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.isHeated',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'isHeated'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: []
                    }
                ],
                inputPaths: ['ec4a09b2-0c63-4306-b933-a68c7bcda90e'],
                outputPaths: ['d84d4798-70de-4b9f-8a93-e45175ca95d6']
            },
            {
                id: '167c5486-042d-4c42-897b-41409947e39f',
                definitionId: '8c7a136e-382f-48ed-8932-208c21f2ece8',
                order: 7,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'EXTLp',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'zSVzq',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'uUt7m',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[0].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['889dcef7-9a61-4553-8531-434adb0b273e'],
                outputPaths: ['d40da010-3bd9-43d0-afe9-721016a7920a']
            },
            {
                id: 'e1465c89-7692-40eb-b550-63bce3b73810',
                definitionId: '970ba7e9-7928-4133-8371-6169ecdaa952',
                order: 8,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'sYTNZ',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ]
                    },
                    {
                        slotId: 'QLrvr',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ]
                    },
                    {
                        slotId: 'IykMS',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[1].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ]
                    }
                ],
                outputPaths: ['3affb21c-8ee1-4094-8b54-5f302f3128b1'],
                inputPaths: ['d40da010-3bd9-43d0-afe9-721016a7920a']
            },
            {
                id: '3affb21c-8ee1-4094-8b54-5f302f3128b1',
                definitionId: '6b62dd2e-544c-4f45-bdc4-927cd30ce0a5',
                order: 9,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['689dcd68-5131-4bc0-acc1-d0fc656053cf', 'd4a9aabc-8dba-4278-a368-cd5b3a0c102b'],
                inputPaths: ['e1465c89-7692-40eb-b550-63bce3b73810']
            },
            {
                id: 'd4a9aabc-8dba-4278-a368-cd5b3a0c102b',
                definitionId: 'f9b286e4-1603-4856-85cc-065224fd16ad',
                order: 10,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'dgf7J',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 2
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '2'
                            }
                        ]
                    },
                    {
                        slotId: '0o8X0',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 2
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '2'
                            }
                        ]
                    },
                    {
                        slotId: 'mlqcJ',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[2].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 2
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '2'
                            }
                        ]
                    }
                ],
                inputPaths: ['3affb21c-8ee1-4094-8b54-5f302f3128b1'],
                outputPaths: ['69f0ea13-9d5f-45a3-acc2-aa4c9a139303']
            },
            {
                id: '69f0ea13-9d5f-45a3-acc2-aa4c9a139303',
                definitionId: '09bcf39d-3123-4068-a2b6-e344e76e812d',
                order: 11,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['689dcd68-5131-4bc0-acc1-d0fc656053cf', '3b442e55-4dbc-485b-8018-3efe8ab38ed1'],
                inputPaths: ['d4a9aabc-8dba-4278-a368-cd5b3a0c102b']
            },
            {
                id: '3b442e55-4dbc-485b-8018-3efe8ab38ed1',
                definitionId: '107e7c2b-82fc-4eff-8dd8-dfa9076a23a8',
                order: 12,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'BAXUh',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 3
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '3'
                            }
                        ]
                    },
                    {
                        slotId: '20QSM',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 3
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '3'
                            }
                        ]
                    },
                    {
                        slotId: 'rcAT6',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[3].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 3
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '3'
                            }
                        ]
                    }
                ],
                inputPaths: ['69f0ea13-9d5f-45a3-acc2-aa4c9a139303'],
                outputPaths: ['feebea45-d272-4ef4-a992-d20db52c9de9']
            },
            {
                id: 'feebea45-d272-4ef4-a992-d20db52c9de9',
                definitionId: '544d20ec-c5ce-426d-b18a-58f4247cb97b',
                order: 13,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['689dcd68-5131-4bc0-acc1-d0fc656053cf', '3e76db6b-d9e0-498c-830e-1c0af5f72e5c'],
                inputPaths: ['3b442e55-4dbc-485b-8018-3efe8ab38ed1']
            },
            {
                id: '3e76db6b-d9e0-498c-830e-1c0af5f72e5c',
                definitionId: '24328abf-54ce-4e2c-b802-5c8e63bda175',
                order: 14,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: '703tf',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 4
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '4'
                            }
                        ]
                    },
                    {
                        slotId: 'v7E7U',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 4
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '4'
                            }
                        ]
                    },
                    {
                        slotId: '0CGaq',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[4].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 4
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '4'
                            }
                        ]
                    }
                ],
                inputPaths: ['feebea45-d272-4ef4-a992-d20db52c9de9'],
                outputPaths: ['3b187ebf-d639-4664-a24b-69965ac7ca1e']
            },
            {
                id: '3b187ebf-d639-4664-a24b-69965ac7ca1e',
                definitionId: 'f9f40024-2a79-420a-8700-cd2df683f552',
                order: 15,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['689dcd68-5131-4bc0-acc1-d0fc656053cf', '0ecd4146-580b-4780-83c7-37a8369bffea'],
                inputPaths: ['3e76db6b-d9e0-498c-830e-1c0af5f72e5c']
            },
            {
                id: 'fa7d7073-c638-4f8d-81a7-4b4d8b9b38a5',
                definitionId: 'e2fb7a73-51cc-441c-84cb-1ea225e7b636',
                order: 16,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64', 'c905e918-677a-42e7-a53b-5c14fc46e88b'],
                inputPaths: ['1e3be7e9-c949-419c-88a0-8fbdd79efd53']
            },
            {
                id: 'aa9a06a3-7124-47b6-ac59-7588b5bfd209',
                definitionId: 'f3e467e1-3c44-4407-a0d4-a71e532aa2a0',
                order: 17,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'oNcrN',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ]
                    },
                    {
                        slotId: 'gqOka',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ]
                    },
                    {
                        slotId: 'DX4wfSI',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ]
                    }
                ],
                outputPaths: ['9778e1ae-4b1f-4db3-9766-02e241f2ffe8'],
                inputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64']
            },
            {
                id: '9778e1ae-4b1f-4db3-9766-02e241f2ffe8',
                definitionId: '51086802-eb24-41b8-9585-9eb6d1bbe5be',
                order: 18,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'nvQzO',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[1]}.id}.zones[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '1'
                            }
                        ]
                    }
                ],
                outputPaths: ['a808d997-db6f-4b61-a08f-cc53a51abb16'],
                inputPaths: ['aa9a06a3-7124-47b6-ac59-7588b5bfd209']
            },
            {
                id: 'a808d997-db6f-4b61-a08f-cc53a51abb16',
                definitionId: 'cc8eb0f9-d0ec-47f0-abfb-69c8a6c9b8f3',
                order: 19,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'kS9fr',
                        compiledPath: {
                            originalPath: 'variables.rooms.{inputs.selectedRoomId}.heatSourcesCount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSourcesCount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['889dcef7-9a61-4553-8531-434adb0b273e'],
                inputPaths: ['9778e1ae-4b1f-4db3-9766-02e241f2ffe8']
            },
            {
                id: '7d4e4285-ff94-459e-97df-c9ea61d9de64',
                definitionId: '5a16e6b0-0749-4c77-a296-031078f3228b',
                order: 20,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'e8g67',
                        compiledPath: {
                            originalPath:
                                'project.building.slabs.{ID(slab):project.building.slabs.{ID(slab):project.building.rooms.{inputs.selectedRoomId}.slabIds.[0]}.id}.zones[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'slabs'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'slab',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'slabs'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'slab',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'slabIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#SLAB_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                outputPaths: ['aa9a06a3-7124-47b6-ac59-7588b5bfd209'],
                inputPaths: [
                    'fa7d7073-c638-4f8d-81a7-4b4d8b9b38a5',
                    '3fa70af6-5d0e-434d-b5e1-75dd17f15f37',
                    'b57c97ab-7a05-4d8f-9feb-62668e170451',
                    'ddfe72d5-4cec-4997-8ed5-48a8e5edef01',
                    '4b27e496-21b1-4a58-adc9-7a90e82d1f49',
                    '7146f308-0c51-413c-9619-a4bf1eb76cab',
                    '712ee9ce-c68f-4ba0-94ef-5ce16ca2d5b9'
                ]
            },
            {
                id: 'c905e918-677a-42e7-a53b-5c14fc46e88b',
                definitionId: '9b6d4a8a-8270-40ee-a9b2-fb2e06a14857',
                order: 21,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'WjRs9',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'L4XxJ',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: '6IzyEz4',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['fa7d7073-c638-4f8d-81a7-4b4d8b9b38a5'],
                outputPaths: ['adf638fa-6b63-4ab9-a718-22574fd9c105']
            },
            {
                id: '82cd37ec-14d1-4a66-9724-ed99cf968054',
                definitionId: '0efc0c86-95c6-4d5c-85a7-630326a7259b',
                order: 22,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'Mfjon',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[0]',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'residents'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'IB6vY',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.residents.[1]',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'residents'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 1
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#RESIDENT_HEAT_SOURCE_IDX',
                                value: '1'
                            }
                        ]
                    }
                ],
                outputPaths: ['1e3be7e9-c949-419c-88a0-8fbdd79efd53'],
                inputPaths: ['d84d4798-70de-4b9f-8a93-e45175ca95d6']
            },
            {
                id: '1e3be7e9-c949-419c-88a0-8fbdd79efd53',
                definitionId: '200163b8-16cb-4fc9-ade0-bbddac1cf0ed',
                order: 23,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'gPAsx',
                        compiledPath: {
                            originalPath: 'variables.rooms.{inputs.selectedRoomId}.wallsCount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'wallsCount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['fa7d7073-c638-4f8d-81a7-4b4d8b9b38a5'],
                inputPaths: ['82cd37ec-14d1-4a66-9724-ed99cf968054']
            },
            {
                id: 'd84d4798-70de-4b9f-8a93-e45175ca95d6',
                definitionId: '2f0d021b-351f-4421-bcc8-c4025bc3d973',
                order: 24,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: '1DWKl',
                        compiledPath: {
                            originalPath: 'variables.showHumanHeatSources',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'variables'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'showHumanHeatSources'
                                }
                            ],
                            dynamicSlots: []
                        },
                        pathPlaceholders: []
                    }
                ],
                outputPaths: ['82cd37ec-14d1-4a66-9724-ed99cf968054'],
                inputPaths: ['765f97c5-3bf3-440f-bb50-a253497cbd0a']
            },
            {
                id: '0ecd4146-580b-4780-83c7-37a8369bffea',
                definitionId: 'd6f914d4-c160-4646-be44-bc03f406a57d',
                order: 25,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'rWQGX',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 5
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '5'
                            }
                        ]
                    },
                    {
                        slotId: 'tMxih',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].connectedLoad',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 5
                                },
                                {
                                    kind: 'PROP',
                                    name: 'connectedLoad'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '5'
                            }
                        ]
                    },
                    {
                        slotId: '8Sn7o',
                        compiledPath: {
                            originalPath: 'project.building.rooms.{inputs.selectedRoomId}.heatSources.[5].amount',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'rooms'
                                },
                                {
                                    kind: 'DYNAMIC',
                                    slot: 0,
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'heatSources'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 5
                                },
                                {
                                    kind: 'PROP',
                                    name: 'amount'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#HEAT_SOURCE_IDX',
                                value: '5'
                            }
                        ]
                    }
                ],
                outputPaths: ['689dcd68-5131-4bc0-acc1-d0fc656053cf'],
                inputPaths: ['3b187ebf-d639-4664-a24b-69965ac7ca1e']
            },
            {
                id: 'd40da010-3bd9-43d0-afe9-721016a7920a',
                definitionId: '0d05f17c-d1f2-4ca6-bf7f-000093e6916c',
                order: 26,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['689dcd68-5131-4bc0-acc1-d0fc656053cf', 'e1465c89-7692-40eb-b550-63bce3b73810'],
                inputPaths: ['167c5486-042d-4c42-897b-41409947e39f']
            },
            {
                id: 'adf638fa-6b63-4ab9-a718-22574fd9c105',
                definitionId: 'efba94f7-d5c4-42a3-8f4f-4d919308e8ad',
                order: 27,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: '8RZaW',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['c905e918-677a-42e7-a53b-5c14fc46e88b'],
                outputPaths: ['db7ab855-2644-4499-936a-8d754f2fb5a5']
            },
            {
                id: '3fa70af6-5d0e-434d-b5e1-75dd17f15f37',
                definitionId: 'cafc66e8-2a92-46be-906e-00a1c899dbc9',
                order: 28,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64', 'ab2b14fa-c3cb-4c0d-8cac-f2b1fa4100f5'],
                inputPaths: ['db7ab855-2644-4499-936a-8d754f2fb5a5']
            },
            {
                id: 'ab2b14fa-c3cb-4c0d-8cac-f2b1fa4100f5',
                definitionId: 'f1b9840a-1fa0-480b-9ff9-84edd17713d5',
                order: 29,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: '3ZCF6',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'D2QqX',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            }
                        ]
                    },
                    {
                        slotId: 'QsY6FMP',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['3fa70af6-5d0e-434d-b5e1-75dd17f15f37'],
                outputPaths: ['a20dcfc4-c156-4ee0-a1b0-a7866307c9e9']
            },
            {
                id: 'a20dcfc4-c156-4ee0-a1b0-a7866307c9e9',
                definitionId: 'd8007702-f4ff-4327-a17c-1e66515c582e',
                order: 30,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'rcyqO',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 1
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['ab2b14fa-c3cb-4c0d-8cac-f2b1fa4100f5'],
                outputPaths: ['b9cfed35-6423-48de-a86c-06d6a5b8488b']
            },
            {
                id: 'b9cfed35-6423-48de-a86c-06d6a5b8488b',
                definitionId: '32cc9dce-ddc3-4638-bca4-f76c89f3c0c5',
                order: 31,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'Bu3XJ',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 1
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'W2F3h',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 1
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'PDfTH',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[1]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 1
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '1'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                outputPaths: ['b57c97ab-7a05-4d8f-9feb-62668e170451'],
                inputPaths: ['a20dcfc4-c156-4ee0-a1b0-a7866307c9e9']
            },
            {
                id: 'b57c97ab-7a05-4d8f-9feb-62668e170451',
                definitionId: '29e0dd9b-5fc8-4dd2-8272-303d8de1d854',
                order: 32,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64', '9144f909-1c6b-4355-b94d-0e1ae8818bc5'],
                inputPaths: ['b9cfed35-6423-48de-a86c-06d6a5b8488b']
            },
            {
                id: '9144f909-1c6b-4355-b94d-0e1ae8818bc5',
                definitionId: '7d3eaefe-4611-4fae-a407-65d6a962ff92',
                order: 33,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'U3i0D',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'ayS6C',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            }
                        ]
                    },
                    {
                        slotId: 'nvtGKwG',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['b57c97ab-7a05-4d8f-9feb-62668e170451'],
                outputPaths: ['d8424341-f431-4c67-9049-0c8e6c4f2f83']
            },
            {
                id: 'd8424341-f431-4c67-9049-0c8e6c4f2f83',
                definitionId: '9637aef7-13be-4d1c-b90f-eb78e32f3a1a',
                order: 34,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'lNwKd',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 2
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['9144f909-1c6b-4355-b94d-0e1ae8818bc5'],
                outputPaths: ['f2ef24f9-c0f0-4791-b041-a3287c14037f']
            },
            {
                id: 'f2ef24f9-c0f0-4791-b041-a3287c14037f',
                definitionId: '3f807407-54f3-49e4-b3d1-4c55af45bf5e',
                order: 35,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'um6mt',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 2
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'RtvVd',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 2
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'PWp7P',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[2]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 2
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '2'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['d8424341-f431-4c67-9049-0c8e6c4f2f83'],
                outputPaths: ['ddfe72d5-4cec-4997-8ed5-48a8e5edef01']
            },
            {
                id: 'db7ab855-2644-4499-936a-8d754f2fb5a5',
                definitionId: '7a0de79a-c572-4bb1-832e-90376a47f52d',
                order: 36,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'gQbTp',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'bdjiZ',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'JS0MP',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[0]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 0
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '0'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                outputPaths: ['3fa70af6-5d0e-434d-b5e1-75dd17f15f37'],
                inputPaths: ['adf638fa-6b63-4ab9-a718-22574fd9c105']
            },
            {
                id: 'ddfe72d5-4cec-4997-8ed5-48a8e5edef01',
                definitionId: '51b381f0-3763-4b7e-85cf-0382fed82651',
                order: 37,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64', 'cb6476d0-b430-469f-9a4f-b5a8286b7397'],
                inputPaths: ['f2ef24f9-c0f0-4791-b041-a3287c14037f']
            },
            {
                id: 'cb6476d0-b430-469f-9a4f-b5a8286b7397',
                definitionId: '56003e72-c67c-4e79-9dc7-60c7ca403035',
                order: 38,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'MuLvM',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'uS8jU',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            }
                        ]
                    },
                    {
                        slotId: '928JgVM',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['ddfe72d5-4cec-4997-8ed5-48a8e5edef01'],
                outputPaths: ['f3749180-a380-4ed4-a26a-cb55d68827f0']
            },
            {
                id: 'f3749180-a380-4ed4-a26a-cb55d68827f0',
                definitionId: 'db9fc88d-d439-492b-a43d-584bc4b5be23',
                order: 39,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: '2Slp3',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 3
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['cb6476d0-b430-469f-9a4f-b5a8286b7397'],
                outputPaths: ['aa60d304-7e3f-4114-a0e6-bab725c19742']
            },
            {
                id: 'aa60d304-7e3f-4114-a0e6-bab725c19742',
                definitionId: 'b8e291e0-711c-42d2-af35-ca62423a05a9',
                order: 40,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'XYH7d',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 3
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'bF0pJ',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 3
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'nCswy',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[3]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 3
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '3'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['f3749180-a380-4ed4-a26a-cb55d68827f0'],
                outputPaths: ['4b27e496-21b1-4a58-adc9-7a90e82d1f49']
            },
            {
                id: '4b27e496-21b1-4a58-adc9-7a90e82d1f49',
                definitionId: '13655091-c342-43dd-adff-8cdf1dc6cfa2',
                order: 41,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64', '1d31e0af-7922-4930-9e40-5cf654432b6b'],
                inputPaths: ['aa60d304-7e3f-4114-a0e6-bab725c19742']
            },
            {
                id: '1d31e0af-7922-4930-9e40-5cf654432b6b',
                definitionId: '2b81c2e6-b2d3-4bcc-82b7-bf4251eebdec',
                order: 42,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'vuoXU',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: '2EKW0',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            }
                        ]
                    },
                    {
                        slotId: 'cC062PP',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['4b27e496-21b1-4a58-adc9-7a90e82d1f49'],
                outputPaths: ['9d4551d1-df66-46ce-af25-5793767dbc72']
            },
            {
                id: '9d4551d1-df66-46ce-af25-5793767dbc72',
                definitionId: '522dc05f-5e4e-41a3-be9f-8a710bd101f2',
                order: 43,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'LBGaB',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 4
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['1d31e0af-7922-4930-9e40-5cf654432b6b'],
                outputPaths: ['a73780be-9b50-486c-99cd-3acea3e98d27']
            },
            {
                id: 'a73780be-9b50-486c-99cd-3acea3e98d27',
                definitionId: 'a5644f59-e974-45ca-a3ab-6553a38854b6',
                order: 44,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'IflcM',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 4
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'qMHVn',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 4
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'mw37V',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[4]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 4
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '4'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['9d4551d1-df66-46ce-af25-5793767dbc72'],
                outputPaths: ['7146f308-0c51-413c-9619-a4bf1eb76cab']
            },
            {
                id: '7146f308-0c51-413c-9619-a4bf1eb76cab',
                definitionId: 'b7f99c2a-3e3d-415a-b956-5b78a975f55d',
                order: 45,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [],
                outputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64', 'ef775efb-7b0c-4407-9b5c-fcdb8e39d894'],
                inputPaths: ['a73780be-9b50-486c-99cd-3acea3e98d27']
            },
            {
                id: 'ef775efb-7b0c-4407-9b5c-fcdb8e39d894',
                definitionId: '54f5455e-180c-4785-b010-9a2a57dc98bc',
                order: 46,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: 'y1mmy',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'ygIJy',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.orientation',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'orientation'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            }
                        ]
                    },
                    {
                        slotId: 'rIyPjLE',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].id',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'id'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['7146f308-0c51-413c-9619-a4bf1eb76cab'],
                outputPaths: ['da7ed407-a1b3-4ac4-b50a-d1f4882fe407']
            },
            {
                id: 'da7ed407-a1b3-4ac4-b50a-d1f4882fe407',
                definitionId: '0100ad45-7715-425b-a2d2-b74b9252084a',
                order: 47,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: '7WrJq',
                        compiledPath: {
                            originalPath:
                                'project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.zones.[0].adjacentTo.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'walls'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'wall',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'walls'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'wall',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'rooms'
                                                },
                                                {
                                                    kind: 'DYNAMIC',
                                                    slot: 0,
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'wallIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 5
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'zones'
                                },
                                {
                                    kind: 'INDEX',
                                    index: 0
                                },
                                {
                                    kind: 'PROP',
                                    name: 'adjacentTo'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#ZONE_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                inputPaths: ['ef775efb-7b0c-4407-9b5c-fcdb8e39d894'],
                outputPaths: ['712ee9ce-c68f-4ba0-94ef-5ce16ca2d5b9']
            },
            {
                id: '712ee9ce-c68f-4ba0-94ef-5ce16ca2d5b9',
                definitionId: 'b665afd1-addb-4df1-abc4-2334ac285d74',
                order: 48,
                parentId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
                slots: [
                    {
                        slotId: '7WAE7',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.area',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 5
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'area'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'Wv3IO',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.type',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 5
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'type'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    },
                    {
                        slotId: 'SC5Qz',
                        compiledPath: {
                            originalPath:
                                'project.building.windows.{ID(window):project.building.windows.{ID(window):project.building.walls.{ID(wall):project.building.walls.{ID(wall):project.building.rooms.{inputs.selectedRoomId}.wallIds.[5]}.id}.windowIds.[0]}.id}.typeOfSunProtection',
                            tokens: [
                                {
                                    kind: 'PROP',
                                    name: 'project'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'building'
                                },
                                {
                                    kind: 'PROP',
                                    name: 'windows'
                                },
                                {
                                    kind: 'ACTION',
                                    actionType: 'ID',
                                    category: 'window',
                                    targetTemplate: [
                                        {
                                            kind: 'PROP',
                                            name: 'project'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'building'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'windows'
                                        },
                                        {
                                            kind: 'ACTION',
                                            actionType: 'ID',
                                            category: 'window',
                                            targetTemplate: [
                                                {
                                                    kind: 'PROP',
                                                    name: 'project'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'building'
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'walls'
                                                },
                                                {
                                                    kind: 'ACTION',
                                                    actionType: 'ID',
                                                    category: 'wall',
                                                    targetTemplate: [
                                                        {
                                                            kind: 'PROP',
                                                            name: 'project'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'building'
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'walls'
                                                        },
                                                        {
                                                            kind: 'ACTION',
                                                            actionType: 'ID',
                                                            category: 'wall',
                                                            targetTemplate: [
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'project'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'building'
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'rooms'
                                                                },
                                                                {
                                                                    kind: 'DYNAMIC',
                                                                    slot: 0,
                                                                    isIndex: false
                                                                },
                                                                {
                                                                    kind: 'PROP',
                                                                    name: 'wallIds'
                                                                },
                                                                {
                                                                    kind: 'INDEX',
                                                                    index: 5
                                                                }
                                                            ],
                                                            isIndex: false
                                                        },
                                                        {
                                                            kind: 'PROP',
                                                            name: 'id'
                                                        }
                                                    ],
                                                    isIndex: false
                                                },
                                                {
                                                    kind: 'PROP',
                                                    name: 'windowIds'
                                                },
                                                {
                                                    kind: 'INDEX',
                                                    index: 0
                                                }
                                            ],
                                            isIndex: false
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'id'
                                        }
                                    ],
                                    isIndex: false
                                },
                                {
                                    kind: 'PROP',
                                    name: 'typeOfSunProtection'
                                }
                            ],
                            dynamicSlots: [
                                {
                                    expression: 'inputs.selectedRoomId',
                                    tokens: [
                                        {
                                            kind: 'PROP',
                                            name: 'inputs'
                                        },
                                        {
                                            kind: 'PROP',
                                            name: 'selectedRoomId'
                                        }
                                    ]
                                }
                            ]
                        },
                        pathPlaceholders: [
                            {
                                identifier: '#WALL_IDX',
                                value: '5'
                            },
                            {
                                identifier: '#WINDOW_IDX',
                                value: '0'
                            }
                        ]
                    }
                ],
                outputPaths: ['7d4e4285-ff94-459e-97df-c9ea61d9de64'],
                inputPaths: ['da7ed407-a1b3-4ac4-b50a-d1f4882fe407']
            }
        ],
        startingPoint: {
            blockId: 'ec4a09b2-0c63-4306-b933-a68c7bcda90e',
            subsectionId: 'ed4ac50c-c7cc-4035-b41d-a06d89ae3b49',
            sectionId: '4c4dae00-943b-4a9f-b506-b0b7dd40fabb'
        }
    },
    version: '2.0.0'
} as unknown as FrontendConfiguration;
